export default {
  app: {
    title: '{{brokerName}}',
  },
  impersonate: {
    caution:
      'You are now impersonating. Please close this window when you are done.',
    logout: 'Log Out',
  },
  assistedBanner: {
    title: 'Assisted registration for',
    logout: 'Save & close',
  },
  missingInfo: {
    bannerText:
      'Some information from your assisted registration is missing.  Please review and complete your application.',
  },
  apiErrors: {
    TooManyRequests: 'Too many requests. Please try again later.',
    EmailAddressIsInvalid: 'Email address is invalid.',
    EmailNotValid: 'Email address is invalid.',
    InvalidToken: 'You already changed your password.',
    ApplicationAlreadyCreated: 'Application already submitted.',
    Authentication: 'Invalid username and/or password.',
    NetworkError: 'Network Error.',
    InternalServerError: 'Internal Server Error.',
    UsernameAlreadyExists: 'Username already exists.',
    UserAlreadyExists: 'Your application is already created.',
    Error_BrokerNotFound: 'Broker not found.',
    Error_AccountNotFound: 'Account not found.',
    Error_PermissionDenied: 'Permission denied.',
    Order_InsufficientFunds: 'Insufficient funds.',
    Order_InsufficientQuantity: 'Insufficient quantity.',
    Order_OrderTypeIsNotAllowed: 'Order type is not allowed.',
    Order_ProductNotFound: 'Product not found.',
    Order_ProductIsNotAllowedForBuy: 'Product is not allowed for buy.',
    Order_ProductIsNotAllowedForTrading: 'Product is not allowed for trading.',
    Order_ProductIsNotAllowedForIraAccount:
      'Product is not allowed for ira account.',
    Order_InvalidQuantity: 'Invalid quantity.',
    Order_InvalidAmount: 'Invalid amount.',
    Order_InvalidPercentage: 'Invalid percentage.',
    Order_ProductIsAllowedOnlyForCash: 'Product is allowed only for cash.',
    Order_CashSellOrderIsNotAllowed: 'Cash sell order is not allowed.',
    Order_ProductIsNotAvailableForBuy: 'Product is not available for buy.',
    Order_ProductIsNotAvailableForSell: 'Product is not available for sell.',
    Order_ProductIsNotAvailableForImmediateExecution:
      'Product is not available for immediate execution.',
    Order_AchDepositMinLimit: 'AchDepositMinLimit',
    Order_AchDepositMaxLimit: 'AchDepositMaxLimit',
    Account_StatementNotFound: 'Statement not found.',
    Account_InvoiceNotFound: 'Invoice not found.',
    Account_1099DocumentNotFound: 'Document not found.',
    Banking_BankNotFound: 'Bank not found.',
    Banking_BankAccountNotFound: 'Bank account not found.',
    Banking_BankAccountMustBeActivated: 'Bank account must be activated.',
    Banking_ReceivingBankAccountDoesNotExist:
      'Receiving bank account does not exist.',
    Banking_RoutingNumberInvalid: 'Routing number invalid',
    InvalidABARoutingNumber: 'Routing number invalid',
    Users_OldPasswordNotMatching: 'Old password not matching',
    ThereArePendingACHDepositRequests:
      'Remove bank account could not be completed. There are pending ACH Deposit Requests.',
    securityQuestionWrong: 'Wrong answer.',
    wrongUsernameOrPassword:
      'An incorrect username or password has been entered.  Please try again.',
    TradecoreExecutionError: 'The provided amount is not valid.',
    Error_AddressUidIsNull: 'The provided address is invalid.',
    Error_BrokerSymbolNotFound: 'The provided broker symbol is not found.',
    Order_RegistrationCompletedChangesNotAllowed: '',
    Order_WithdrawalIsLocked: 'Withdrawal is locked.',
    Order_UnknownEmailType: 'Unknow email type.',
    Order_UnsupportedIRATrusteeType: 'Unsupported IRA Trustee type.',
    Order_ActionNotAllowedForNonIRAAccount:
      'Action not allowed for non IRA Account.',
    Order_EntrustAccountCannotSubmitIraCHECKFeeWithdrawalOrder: '',
    Order_EquityAccountCannotSubmitIraWIREFeeWithdrawalOrder:
      'Equity account cannot submit IRA Wire withdrawal order.',
    Order_ProductOutOfStock: 'Product is out of stock.',
    BankAccountAchStateMustBeActivated:
      'Bank Account ACH state must be activated.',
    Order_AutomaticFundingNotEnabled: 'Automatic funding is not enabled.',
    Order_UnassessedStorageFees: 'Unassesed Storage Fees.',
    AccountIsNotIRA: 'Account is not IRA type.',
    IRATypeNotSupported: 'IRA type is not supported.',
    ChangeRoleToNotificationOnlyNotAllowed:
      'Change to Notification Only role is not allowed.',
    UTMAFullAccessNotAllowed: 'UTMA Full access is not allowed.',
    EquityIRAServiceError: '',
    Banking_BankAccountNotSecure: 'Bank Account is not secure.',
    Banking_UnknownClientBankAccountType: 'Unknown Bank Account type.',
    BankAccountInUse: 'Bank Account is in use.',
    BothBanksAreSet: 'Both Banks are set.',
    BankMustBeSet: 'Bank must be set.',
    BankAddressMustBeSet: 'Bank Address must be set.',
    ContextDtosIsNull: '',
    BankAccountStateFilterTypeIsNotDefined: '',
    BankAccountStateFilterIsNotValid: '',
    BankAccountUidIsEmpty: '',
    BankAccountDoesNotExist: 'Bank Account does not exist.',
    SubmitterUidIsEmpty: '',
    NoteIsEmpty: '',
    BankAccountACHStateIsNotValidForVerificationPaymentsSubmission: '',
    InternalBankAccountUidIsEmpty: '',
    InternalBankAccountDoesNotExist: '',
    BankAccountDtoIsNull: '',
    UidIsEmpty: '',
    SubmitterGuidIsEmpty: '',
    NicknameLengthIsNotValid: '',
    AccountHolderFullNameIsNotValid: '',
    AccountHolderFullNameLengthIsNotValid: '',
    AccountHolderFullName2IsNotValid: '',
    AccountHolderFullName2LengthIsNotValid: '',
    AccountTypeIsUnknown: 'Account Type is unknown.',
    AccountNumberIsNotValid: 'Account Number is not valid.',
    AccountNumberLengthIsNotValid: 'Account Number length is not valid.',
    AccountTypeIsNotDefined: 'Account Type is not defined.',
    AccountHolderFullNameIsNullOrEmpty: 'Account Holder full name is empty.',
    BankAccountStatusTypeIsUnknown: 'Bank Account status type is unknown.',
    BankAccountStatusTypeIsNotDefined:
      'Bank Account status type is not defined.',
    UidAlreadyExists: '',
    ExistingBankAccountIsPendingVerification:
      'Existing Bank Account is pending verification.',
    OfficialSourceGuidDoesNotExists: '',
    BankAccountIsNotPendingVerification: '',
    BankAccountIsExpired: '',
    BankDtoIsNull: '',
    NameLengthIsNotValid: '',
    ABARoutingCodeIsNullOrEmptyAndCountryIsUSA: '',
    ACHRoutingCodeIsNullOrEmptyAndCountryIsUSA: '',
    IncomingWireRoutingCodeIsNullOrEmptyAndCountryIsUSA: '',
    SwiftCodeIsNullOrEmptyAndCountryIsNotUSA: '',
    SwiftCodeFormatIsNotValid: '',
    NameIsNullOrEmpty: '',
    ABARoutingNumberLengthIsInvalid: '',
    ABARoutingNumberIsNotNumeric: '',
    OfficialSourceGuidIsEmpty: '',
    SortCodeIsNullOrEmptyAndCountryIsUSA: '',
    SortCodeLengthIsInvalid: '',
    SortCodeFormatIsNotValid: '',
    ABARoutingNumberIsNullOrEmpty: '',
    ABARoutingNumberFormatIsNotValid: '',
    NoBankName: '',
    NoBankAccountsToAdd: '',
    ABARoutingNumberIsNotSupported: '',
    ABARoutingNumberIsBlockedForWire: '',
    ABARoutingNumberIsBlockedForACH: '',
    BankAccountActivationDaysIs0: '',
    BankAccountUnknown: '',
    BankAccountFailed: '',
    BankAccountTypeCannotBeBoth: '',
    BankAccountTypeNotSet: '',
    BankAccountPurposeTypeNotSet: '',
    BankAccountAlreadyAdded: '',
    InvalidMetalType: '',
    MetalStreamProductConfigurationIsNotSet: '',
    InvalidProductCode: '',
    BrokerAccountIsAipAdministrative: '',
    BrokerIsNotInAipProgram: '',
    BrokerAccountIsAccumulationActive: '',
    InstructionsAmountIsNegative: '',
    AchBankAccountIsRequired: '',
    UseClientBalanceAndAchBankAccountProvided: '',
    InstructionsPercentageIsInvalid: '',
    InvalidProduct: '',
    InstructionsPercentageSumIsInvalid: '',
    InvalidParameters: 'Invalid username and/or password.',
    DocumentNameIsRequired: '',
    UnsupportedAccountDocumentType: '',
    FileForDownloadNotFound: '',
    DownloadCenterContentsCategoryNotFound: '',
    DownloadCenterDocumentNotFound: '',
    TradingNotOpen: '',
    OrderTypeNotAllowed: '',
    AddressUidIsNull: '',
    FinancialTransactionForDeliveryNotFound: '',
    ForFractionalAipMustBeActive: '',
    FractionalNotAllowedForDelivery: '',
    BrokerAccountNotFound: 'Broker Account not found.',
    AuthorizedUsersNotFound: 'Authorized User not found.',
    AddressNotFound: 'Address not found.',
    PermissionsNotFound: 'Permission not found.',
    UsernameDoesNotExist: 'User with provided username or email does not exist',
    AccountIsPrevented: '',
    AccountIsRejectedOrExpired: '',
    AccountNotYetApproved: '',
    WrongPasswordAccountIsLocked: '',
    WrongCredentials:
      'An incorrect password has been entered for the selected username.  Please try again.',
    LogonIsMissingIdentityEntityGuid: '',
    AccountIsInvited: '',
    AccountIsLocked: '',
    AccountIsInactive: '',
    UnknownAccountStatus: '',
    UpdateIsNotSupported: '',
    UserNotFound: 'User not found.',
    IncorrectAnswer: '',
    LogonNotFound: '',
    TokenHasExpired: 'The provided reset token has expired.',
    ErrorSendingMail: '',
    RemoveAddressNotAllowed: '',
    UserStatusChangeNotAllowed: '',
    EmailNullOrEmpty: '',
    BrokerSymbolNotFound: '',
    BrokerSecurityNotFound: '',
    SomethingWentWrong: 'Something went wrong',
    WizardValidation_UserNotFound:
      'An incorrect password has been entered for the selected username.  Please try again.',
    InvalidCredentials:
      'An incorrect password has been entered for the selected username.  Please try again.',
    TokenDoesNotMatch: 'The provided reset token has expired or is not valid.',
    WizardValidation_TokenDoesNotMatch:
      'The provided reset token has expired or is not valid.',
    CustodianAccountTypeIsNotAllowed: 'Custodian Account Type is not allowed.',
    TrackingDetailsModelIsNull: 'Tracking Details are required.',
    PhoneModel_Iso3CountryCodeIsInvalid: 'Invalid Country ISO3 code.',
    PhoneModel_PhoneNumberIsTooShort: 'Phone number is too short',
    PhoneModel_PhoneNumberIsTooLong: 'Phone number is too long',
    PhoneModel_PhoneNumberIsInvalid: 'Phone number is invalid',
    PhoneModel_PhoneNumberIsInvalidLength: 'Phone number is invalid length',
    PhoneModel_AreaCodeIsNullOrEmpty: 'Invalid Area Code',
    WizardValidation_MissingAgreementConsent:
      'Application is not submitted. Agreement Consent is not set. Please try again.',
    WizardValidation_InvalidApplicationUid:
      'Application is not submitted. Application Uid is not valid. Please try again.',
    WizardValidation_ApplicationIsCompleted:
      'Application has been already completed.',
    FundingTypeIsNotDefined: 'Funding type is not defined.',
    FundingAlreadySubmited: 'Funding is already submitted.',
    'Request failed with status code 500': 'Something went wrong',
    SocureRequestError: 'Socure Request is faild. Please try again.',
    SocureDocumentUploadError: 'Image quality is too low. Please try again.',
    SocureKYCError: 'Socure KYC verification is failed. Please try again.',
    SocureCaptureError:
      'An error occurred while capturing photo. Please try again.',
    SocureDocumentVerificationError:
      'Document verification is falid. Please try again.',
    SocureOFACError: '',
    SocureGetReasonCodesError: '',
    StreetIsNullOrEmpty: "Street can't be empty",
    StreetIsInvalidLength:
      'Street name is too long. Max length is 50 characters.',
    CityIsNullOrEmpty: "City can't be empty",
    CityIsInvalidLength: 'City name is too long. Max length is 50 characters. ',
    CountryIso3CodeIsNullOrEmpty: "CountryIso3Code can't be empty",
    CountryIso3CodeIsInvalidLength:
      'CountryIso3Code is too long. Max length is 50 characters.',
    CountryIso3CodeIsInvalid: 'CountryIso3Code is invalid',
    CountryIso2CodeIsNullOrEmpty: "CountryIso2Code can't be empty.",
    CountryIso2CodeIsInvalidLength:
      'CountryIso2Code to long. Max length is 50 characters.',
    CountryIso2CodeIsInvalid: 'CountryIso2Code is invalid.',
    PostalCodeIsNullOrEmpty: "Postal Code can't be empty.",
    PostalCodeIsInvalidLength:
      'Postal Code is too long. Max length is 50 characters.',
    PostalCodeIsInvalid: 'Postal Code  is invalid.',
    StateIsNullOrEmpty: "State can't be empty",
    StateIsInvalidLength:
      'State name is too long. Max length is 50 characters.',
    UsenameDoesNotExist: 'Provided username is invalid or does not exist.',
    InvaildDocument:
      'This file format is unsupported. Please upload either png or jpg.',
    Iso3CountryCodeIsInvalid: 'ISO3 country code is invalid.',
    PhoneNumberIsTooShort: 'Phone number is too short.',
    PhoneNumberIsInvalidLength: 'Phone number has invalid length.',
    PhoneNumberIsTooLong: 'Phone number is too long.',
    PhoneNumberIsInvalid: 'Phone number is invalid.',
    LocalNumberIsNullOrEmpty: 'Local number is invalid',
    UnsupportedDocumentUploadMediaType:
      'Your document was not uploaded because it was not an acceptable file type.  File types accepted: .png, and .jpg.',
    InvalidRecaptchaToken: 'Invalid recaptcha token.',
    GiftStateNotSupported:
      'An UTMA in this state/territory is not yet supported.',
    UserCanNotLogInOrRegister: 'User cannot login or register.',
    InvalidCredentialsBasicAccount: 'User with this username already exists.',
    ApplicationInvitationAlreadyAccepted: 'Invitation is already accepted.',
    InvalidApplicationToken: 'Application token is invalid.',
    PostalCodeNotValid: 'PostalCode is not valid.',
    EmployerZipCodeIsNotValid: 'Zip code is invalid.',
    PasswordIsInvalid: 'Password is not correct.',
    IdentificationTypeIsInvalid: 'Identification type is invalid',
    IDNumberIsInvalid: 'ID number is invalid',
    IDNumberIsNull: 'ID number is null',
    IDIssueDateIsInvalid: 'ID Issue date is invalid',
    IDIssueDateIsNull: 'ID Issue date is null',
    IDExpirationDateIsInvalid: 'ID Expiry date is invalid',
    IDExpirationDateIsNull: 'ID Expiry date is null',
    IssuedByCountryIsInvalid: 'Issued by country is invalid',
    IssuedByCountryIsNull: 'Issued by country is null',
    IssuedByStateIsInvalid: 'Issued by state is invalid',
    IssuedByStateIsNull: 'Issued by state is null',
    AccountPurposeTypeIsNull: 'Account purpose type is null',
    AccountPurposeTypeIsInvalid: 'Account purpose type is invalid',
    InitialFundingSourceTypesIsNull: 'Initial funding source types are null',
    InitialFundingSourceTypesNoneSelected:
      'No initial funding source type selected',
    InitialFundingSourceTypesIsInvalid:
      'Initial funding source types are invalid',
    InitialFundingSourceTypesOtherDetailsMissing:
      'Other details for initial funding source type are missing',
    InitialFundingSourceTypesOtherDetailsNotNeeded:
      'Other details for initial funding source type are not needed',
    OngoingFundingSourceTypesIsNull: 'Ongoing funding source types are null',
    OngoingFundingSourceTypesNoneSelected:
      'No ongoing funding source type selected',
    OngoingFundingSourceTypesIsInvalid:
      'Ongoing funding source types are invalid',
    OngoingFundingSourceTypesOtherDetailsMissing:
      'Other details for ongoing funding source type are missing',
    OngoingFundingSourceTypesOtherDetailsNotNeeded:
      'Other details for ongoing funding source type are not needed',
    LegalEntityNameInvalidLength:
      'Your entity name exceeds the character limit. Please shorten it to 200 characters or less.',
    PhoneNotValid: 'Phone number is invalid',
    EmployerNameIsNull: 'Employer name is required.',
    EmployerAddressLineIsNull: 'Employer address line is required.',
    EmployerAddressLineIsInvalidLength:
      'Employer address line length is invalid.',
    EmployerCityIsNull: 'Employer city is required.',
    EmployerCityIsInvalidLength: 'Employer city length is invalid.',
    EmployerZipCodeIsNull: 'Employer zip code is required.',
    EmployerZipCodeIsInvalidLength: 'Employer zip code length is invalid.',
    EmployerStateIsNull: 'Employer state is required.',
    EmployerStateIsInvalidLength: 'Employer state length is invalid.',
    EmployerStateIsInvalid: 'Employer state is invalid.',
    OccupationCategoryIsNull: 'Occupation category is required.',
    OccupationCategoryIsInvalid: 'Occupation category is invalid.',
    OccupationIsNull: 'Occupation is required.',
    OccupationIsInvalid: 'Occupation is invalid.',
    PriorOccupationCategoryIsNull: 'Prior occupation category is required.',
    PriorOccupationCategoryIsInvalid: 'Prior occupation category is invalid.',
    PriorOccupationIsNull: 'Prior occupation is required.',
    PriorOccupationIsInvalid: 'Prior occupation is invalid.',
    EmploymentStatusTypeIsNull: 'Employment status type is required.',
    IncomeSourceTypeIsNull: 'Income source type is required.',
    IncomeSourceTypeIsInvalid: 'Income source type is invalid.',
  },
  fields: {
    labels: {
      firstName: 'First name',
      middleName: 'Middle name (Optional)',
      lastName: 'Last name',
      suffix: 'Suffix (Optional)',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      custodianName: 'Custodian name',
      accountNumber: 'Account number',
      city: 'City',
      street: 'Street address',
      state: 'State',
      aptOrSuite: 'Apt. / suite',
      postalCode: 'Zip / Postal',
      custodianPhone: 'Custodian phone #',
      custodianFax: 'Custodian fax #',
      iraType: 'IRA Type',
      custodians: 'Custodians',
      personPhone: 'Phone number',
      employerName: 'Employer Name',
      contributionYear: 'Contribution year',
      contributionYearSubtext1: 'Contributions for ',
      contributionYearSubtext2: 'prior tax year ',
      contributionYearSubtext3: 'can be made until ',
      contributionYearSubtext4: 'April 15th',
      contributionYearSubtext5: ' of the current year.',
    },
    errors: {
      validation: {
        emailRequired: 'Email address is required.',
        emailFormat: 'Invalid email address format.',
        emailMaxLength: 'Email must be at most 50 characters long.',
        invalidCharacters: 'You cannot enter invalid characters. ',
        firstName: 'First Name is a required field.',
        firstNameMaxLength: 'First Name must be at most 50 characters long.',
        lastName: 'Last Name is a required field.',
        lastNameMaxLength: 'Last Name must be at most 50 characters long.',
        middleName: 'Maximum length of the Middle Name is 10.',
        middleNameMaxLength: 'Middle Name must be at most 50 characters long.',
        name: 'Name is a required field.',
        phoneNumber: 'Phone Number is a required field.',
        invalidPhoneNumber: 'Phone Number is invalid.',
        password: 'Password is a required field.',
        passwordDifferent: 'Password must not be the same as email.',
        passwordMaxLength: 'Password must be at most 50 characters long.',
        usernameIsRequired: 'Username is a required field.',
        passwordsMatch: 'Passwords must match.',
        passwordStrength:
          'Must be at least 8 characters long. Must contain at least three characters out of the following, one lower case letter, one upper case letter, one digit and one non-alphanumeric character.',
        securityQuestion: 'Security Question is a required field.',
        answer: 'Answer is a required field.',
        streetAddress: 'Street Address is a required field.',
        streetAddressMaxLength:
          'Street Address must be at most 50 characters long.',
        employerStreet: 'Employer Address is required.',
        employerStreetMaxLength:
          'Employer Address must be at most 50 characters long.',
        city: 'City/Town is a required field.',
        cityMaxLength: 'City/Town must be at most 50 characters long.',
        employerCity: 'City is required.',
        employerCityMaxLength:
          'Employer City must be at most 50 characters long.',
        postalCode: 'Postal Code is a required field.',
        postalCodeNotValid: 'Postal Code is not valid.',
        postalCodeRequired: 'Postal Code is a required field.',
        employerPostalCode: 'Zip code is required.',
        ssnDigits: 'Social Security Number should contain only digits.',
        ssnValidation: 'Social Security Number must contain only 9 digits.',
        ssnNotValid: 'Social Security Number is not valid.',
        ssnRequired: 'Social Security Number is a required field.',
        state: 'State is not valid.',
        stateRequired: 'State is required field.',
        employerStateRequired: 'State is required.',
        minorGiftStateRequired: 'Minor Gift State is a required field.',
        countryOfCitizenship: 'Country of Citizenship is a required field.',
        country: 'Country is a required field.',
        countryOfRegistration: 'Country or registration is a required field.',
        company: 'Company Name is a required field.',
        entityName: 'Legal Entity Name is a required field.',
        entityPhoneNumber: "Legal entity's phone number is a required field.",
        taxForms: 'Tax Form is a required field.',
        accountNumber: 'Account Number is a required field.',
        amount: 'Amount is a required field.',
        depositAmount: 'Deposit amount is a required field.',
        cashContributionAmount:
          ' Maximum value for Cash Contribution Amount is {{amount}}.',
        accountType: 'Account Type is a required field',
        transferMethod: 'Transfer Method is a required field.',
        estimatedAmount: 'Estimated Amount of Rollover is a required field.',
        estamatedAmountIntitalDeposit:
          'Estimated Amount of Intitial deposit is a required field.',
        estamatedAmountIntitalDepositNumber:
          'Estimated Amount of Intitial deposit must be a number.',
        estamatedAmountIntitalDepositMin:
          'You must deposit at least {{minValue}}.',
        estamatedAmountIntitalDepositMax:
          'You can deposit maximum {{maxValue}}.',
        estamatedAmountRolloverNumber:
          'Estimated Amount of Rollover must be a number.',
        estamatedAmountExistingIraNumber: 'Estimated Amount must be a number.',
        estamatedAmountCashContributionNumber:
          'Estimated Amount of Cash Contribution must be a number.',
        contributionYear: 'Contribution Year is a required field.',
        contributionAmount: 'Contribution Amount is a required field.',
        dateOfBirth: 'You must be at least 18 years old to create an account.',
        dateOfBirthUtmaCustodian:
          'You must be at least 21 years old to create an account.',
        dateOfBirthUtma:
          'This member must be under 21 years old to create an account.',
        dateOfBirthSecondary:
          '{{applicantName}} has to be at least 18 years old.',
        utmaCountry: 'Country must be USA for UTMA Application type.',
        confirmPassword: 'Confirm Password is a required field.',
        fundingAlreadysubmitted: 'Already submitted funding.',
        IRAFundingType: 'Funding type is unknown.',
        IRAMethodType: 'IRA distribution method type is unknown.',
        IRAaccountType: 'Custodian account type is not allowed.',
        IRAAmount: 'Amount is not valid.',
        invalidApplicationStep:
          'Application step type is not account funding type.',
        day: 'Day is required.',
        minDay: 'Invalid day value.',
        maxDay: 'Invalid day value.',
        minMonth: 'Invalid month value.',
        maxMonth: 'Invalid month value.',
        month: 'Month is required.',
        year: 'Year is required.',
        minYear: 'Invalid year value.',
        maxYear: 'Invalid year value.',
        dateOfBirthInvalid: 'Date of birth is invalid.',
        businessName: 'Business name is required.',
        trustName: 'Trust name is required.',
        trustNameMax: 'Trust name cannot exceed 100 characters',
        businessNameMax: 'Business name cannot exceed 100 characters',
        einDigits: 'EIN Number should contain only digits',
        einValidation: 'EIN must contain only 9 digits',
        einNotValid: 'EIN Number is not valid.',
        einRequired: 'EIN Number is a required field.',
        idTypeRequired: 'Please select identification type',
        idNumberRequired: 'ID number is required',
        idNumberMaxLength: 'ID number must be at most 50 characters long.',
        issueDateRequired: 'Issue date is required',
        issueDateInvalid: 'Issue date must be today or earlier.',
        expiryDateRequired: 'Expiration date is required',
        expiryDateInvalid: 'Expiration date must be a future date.',
        issuedByRequired: 'Issued by field is required',
        mustBeNumber: 'You must enter a number.',
        greaterThanZero: 'This is required field must be greater than 0.',
        identityCountry: 'Try typing a country name.',
        countryRequired: 'Country field is required.',
        minAmount:
          'There is a minimum amount {{minAmount}} limit per deposit {{type}}.',
        maxAmount: 'There is a {{maxAmount}} limit per deposit {{type}}.',
        UserAlreadyExists: 'User already exists.',
        InvalidParameters: 'Invalid username and/or password.',
        custodianName: 'Custodian name is required.',
        custodianPhone: 'Custodian phone is required.',
        personPhoneNumber: 'Phone number is required.',
        personPhoneMaxLength:
          'Phone number must be at most 50 characters long.',
        custodianPhoneIsInvalid: 'Custodian phone is invalid.',
        personPhoneIsInvalid: 'Phone number is invalid.',
        personPhoneNotUSA: 'Phone number must be USA for retirement accounts.',
        custodianFax: 'Custodian fax is required.',
        custodianFaxIsInvalid: 'Custodian phone is invalid.',
        iraType: 'Ira type is required.',
        custodian: 'Custodian is required.',
        personPhone: 'Phone is required field.',
        employmentStatus: 'Employment status is required.',
        employerName: 'Employer Name is required.',
        employerNameMaxLength:
          'Employer Name must be at most 50 characters long.',
        occupationCategory: 'Occupation Category is required.',
        priorOccupationCategory: 'Prior Occupation Category is required.',
        occupation: 'Occupation is required.',
        priorOccupation: 'Prior Occupation is required.',
        sourceOfIncome: 'Source Of Income is required.',
        personalGoal: 'You must select at least one option',
        otherSource: 'Please provide additional details for "Other".',
      },
    },
  },
  common: {
    close: 'Close',
    trademark: 'TM',
    search: 'Search',
    error: 'Error',
    continue: 'Continue',
    labelUsername: 'Username:',
    labelPassword: 'Password:',
    next: 'Next',
    back: 'Back',
    goBack: 'Go Back',
    ok: 'Ok',
    done: 'Done',
    confirm: 'Confirm',
    printDownload: 'Print/Download',
    cancel: 'Cancel',
    remove: 'Remove',
    invite: 'Invite',
    save: 'Save',
    cash: 'Cash',
    complete: 'Complete',
    quantity: 'Quantity',
    download: 'Download',
    moneyCurrencyLeft: '{{money}}',
    moneyCurrencyRight: '{{money}}{{currency}}',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    start: 'Start',
    gold: 'Gold',
    silver: 'Silver',
    agree: 'I Agree',
    delete: 'Delete',
    verify: 'Verify',
    yes: 'Yes',
    no: 'No',
    clearFilters: 'Clear all filters',
    makeDefault: 'Make Default',
    defaultAddress: 'Default Address',
    noResults: 'There are no results.',
    skipForNow: 'Skip for now',
    to: 'to',
    select: 'Select...',
    accept: 'Accept',
    none: 'None',
    date: {
      range: '{{start}} to {{end}}',
    },
    update: 'Update',
    note: 'Note',
    pageNotFoundError: 'Error 404',
    pageNotFound: 'Page Not Found',
    errorPageTitle: 'Error 500',
    errorPageText:
      'We’re sorry, an internal server error came up. Please be patient or try again later.',
  },
  agreementModal: {
    title: 'User Account Agreement',
    titleOne: '{{brokerName}}, LLC',
    titleTwo: 'Account Opening and Disclosure Agreement (the “Agreement”)',
    titleThree: 'Last Updated: April 15, 2019',
    text:
      'The following terms govern your Client Account with {{brokerName}}, LLC (“{{brokerName}}” or “{{brokerCode}}”) including the offering of Precious Metals Products and Services through {{brokerCode}} and any cash balances and Precious Metals held in your Account.',
    investment: {
      title: 'The Investment',
      textOne:
        '{{brokerName}}, LLC, a New York limited liability company, has been formed to provide its Clients with a means to directly buy, store and sell Precious Metals.',
    },
    principalOffices: {
      title: 'Principal Offices',
      phone: 'Phone:',
      website: 'Website:',
      email: 'Email:',
    },
    transactionFees: {
      title: 'Transaction Fees',
      textOne:
        'The price of any Precious Metal purchase or sale order will include a transaction fee (“Transaction Fee”), which will be included in the price shown to the Client on the trading pages and trade confirmations.',
      textTwo:
        'The Transaction Fee will be based on the monetary value of the order and will be used by {{brokerName}} to cover, among other things, trading, transportation (including costs of insuring Precious Metals during transport) and other administrative costs.',
    },
    securedStorageAndServiceFee: {
      title: 'Secured Storage and Service Fee',
      textOne:
        'Clients will be charged a storage fee (the “Storage Fee”) on a monthly basis, in arrears. The Storage Fee will begin to accrue on the settlement date of purchases and will stop accruing on the settlement date minus one for sales.',
      textTwo:
        'The amount of the Storage Fee will be calculated by using the aggregate of the daily accrual of the Client’s settled holdings. Asset Base Fee = (Daily Valuation * BPS)/Number of days in the year. The value of a Client’s Precious Metal holdings for each day will equal such Client’s holdings at the closing of business at the average closing bid price for such day or the last day that such price was available for weekends and business holidays.',
      textThree:
        'The Storage Fee will be used to cover {{brokerName}}’s overhead expenses, including, without limitation, all expenses incurred in connection with the storage, security, insurance and verification of Precious Metals (including fees and expenses paid to the Vaulting Partners and the Auditors (as defined below), expenses associated with preparing reports and valuations, legal expenses, and other operating expenses of {{brokerName}}).',
    },
    otherFees: {
      title: 'Other Fees',
      textOne:
        'Any additional fees such as delivery, funding, etc., will be displayed when executing the appropriate action, and will allow the Client to confirm before submitting the request.',
    },
    redemptions: {
      title: 'Redemptions',
      textOne:
        '{{brokerName}} reserves the right, without prior notice of any kind to the Client, to redeem any Precious Metals in a Client’s account in order to satisfy any obligations of a Client to {{brokerName}} for which Client is in arrears for more than thirty (30) days (the “Obligations”), including without limitation Storage Fees and any other fees and expenses relating to a Client’s account. If {{brokerName}} redeems any of a Client’s Precious Metals for any reason, it will charge the Client a fee of 2.5% of the dollar amount of the Precious Metals redeemed, in addition to the amount required to pay in full all of the Client’s outstanding Obligations.',
    },
    businessDay: {
      title: 'Business Day',
      textOne:
        'A valid business day is one in which the New York Stock Exchange (NYSE) is open for business. Standard trading hours are between 9:00am and 5:15pm EST. Any trading outside of these hours would be considered extended trading hours.',
    },
    tradingDay: {
      title: 'Trading Day',
      textOne:
        'Standard trading hours are between 9:00am and 5:15pm EST. Any trading outside of these hours would be considered extended trading hours.',
    },
    application: {
      title: 'Application',
      textOne:
        '{{brokerName}} Services may be offered through its primary website gbidirect.com, through other websites, officially sponsored client applications, documented application programming interfaces, and other methods. These offerings collectively shall be referred to as the Application, and your Account may be accessible through one or more of these means. This Agreement covers the appropriate use of your Account and the rules that govern that use when accessed through any part of the Application, but not by means other than officially supported by {{brokerCode}}.',
    },
    preciousMetalsProductsandServicesOffering: {
      title: 'Precious Metals Products and Services Offering',
      textOne:
        '{{brokerName}} will process the purchase and sale of sell coins and bars on behalf of its Clients. Purchase orders may be placed in either dollars or for a specific quantity. In the event of a dollar order placement, {{brokerName}} effects the purchase of the quantity of the Product type ordered without exceeding the total dollar amount of the order. All transactions are executed by Gold Bullion International, LLC (“GBI”).',
      textTwo:
        'All Products offered by {{brokerName}} are displayed in its Application. All Products and Service offerings are subject to availability. {{brokerCode}} will use commercially reasonable efforts to accurately reflect the availability of all Products at the time a Client places an order to purchase or commitment to invest in such Product. However, for reasons out of{{brokerCode}}’s control this information may not always be accurate, and all Client indications of intent to purchase are subject to cancellation by {{brokerCode}} for any reason until such time that a purchase or investment is confirmed by {{brokerCode}} to be complete.{{brokerCode}} will not be held responsible for any potential gains or losses that could have been incurred as a result of the failure to complete an order, regardless of the reason.',
      textThree:
        'Certain Products may not be available for purchase or sale during extended trading hours. Please refer to the Product details in the Application for further information.',
    },
    variableWeightProducts: {
      title: 'Variable Weight Products',
      textOne:
        'The actual weight of variable weight bars varies from bar to bar as much as +/- 50 oz. {{brokerName}} will use best efforts to procure bars close to the specified fine weight dependent on dealer supply. Clients will be charged on the actual fine weight of the bar used to fill a purchase order.',
    },
    purchaseSalePrice: {
      title: 'Purchase/Sale Price',
      textOne:
        'When a Client submits a purchase or sale order, {{brokerName}} will use commercially reasonable efforts to execute the order as soon as reasonably practicable after receiving it. For each purchase or sale order, {{brokerName}} will use commercially reasonable efforts to obtain best execution pricing for that order. Orders involving multiple Products may be executed with more than one Dealer (as defined below), and each Product may be purchased or sold at a different price and different Products may be physically delivered at different times.',
    },
    orderPlacement: {
      title: 'Order Placement',
      textOne:
        'All orders must be placed through the Application or over the phone with a {{brokerName}}/GBI representative.',
    },
    settlement: {
      title: 'Settlement',
      textOne:
        'All purchases placed with {{brokerName}} require the Client to first deposit sufficient funds on account to cover the estimated cost of the order, including Transaction Fees, plus an execution buffer to guard against volatility in the market, each of which {{brokerCode}} will disclose prior to placement of the order. These funds will be held in a {{brokerName}} custodial account at a U.S. bank of its choice (currently Bank of America, but subject to change without notice). Clients have the option of maintaining this cash balance at {{brokerName}} for future purchases or withdrawal.',
      textTwo:
        'Upon the confirmation of a purchase order by the Client, {{brokerCode}} will immediately reserve the appropriate amount of these funds for the settlement of the order; however, funds may remain in the account until settlement at a later time (outlined below).',
      textThree:
        'In the case of sales, {{brokerName}} will deposit the proceeds on the Client’s cash balance or send a check or wire for net proceeds to the Client, as per its instructions.',
      textFour:
        'In certain circumstances, physical delivery to {{brokerName}}’s contracted vaults may be delayed due to the transportation requirements of moving Precious Metals; however the title is always transferred on settlement date of the order. Pursuant to the agreement between each Dealer and {{brokerName}}, the Dealers will bear any costs, expenses or liabilities (including replacement costs) if any Precious Metal purchase or sale order is either delayed or not physically delivered after order settlement.',
      textFive:
        '{{brokerName}} will accept Client orders 24 hours per day, 7 days per week. However, because the firm only conducts trading 24 hours a day 5 days a week on days that the NYSE is open for business: i) final Client execution prices for orders placed on weekends or market holidays may vary from the price quoted within the bounds of the execution buffer, if any, quoted at the time of order confirmation; and ii) orders may be subject to suspension or cancellation as detailed below.',
      textSix:
        'Trade settlements will be on trade date + two business days cycle as illustrated below.',
      textSeven:
        'Trades placed after 4:55pm EST will be filled on a best efforts basis for that trade day. The proceeds of a sell order will not be sent until the order has settled.',
      table: {
        tradeDate: 'Trade Date*',
        fromEst: 'From EST',
        toEst: 'To EST',
        settlementDay: 'Settlement Day',
        dayOne: 'Day 1',
        dayTwo: 'Day 2',
        dayThree: 'Day 3',
        dayFour: 'Day 4',
        dayFive: 'Day 5',
        sunFrom: 'Sun 5:15:00 pm',
        monFrom: 'Mon 5:15:00 pm	',
        tueFrom: 'Tue 5:15:00 pm	',
        wedFrom: 'Wed 5:15:00 pm	',
        thursFrom: 'Thurs 5:15:00 pm	',
        monTo: 'Mon 5:14:59 pm',
        tueTo: 'Tue 5:14:59 pm	',
        wedTo: 'Wed 5:14:59 pm	',
        thursTo: 'Thurs 5:14:59 pm	',
        friTo: 'Fri 5:14:59 pm	',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        note: '*Trades Date is based on the time of execution not request.',
      },
    },
    tradeDateTable: {
      tradeDate: 'Trade Date*',
      fromEst: 'From EST',
      toEst: 'To EST',
      settlementDay: 'Settlement Day',
      dayOne: 'Day 1',
      dayTwo: 'Day 2',
      dayThree: 'Day 3',
      dayFour: 'Day 4',
      dayFive: 'Day 5',
      sunFrom: 'Sun 5:15:00 pm',
      monFrom: 'Mon 5:15:00 pm	',
      tueFrom: 'Tue 5:15:00 pm	',
      wedFrom: 'Wed 5:15:00 pm	',
      thursFrom: 'Thurs 5:15:00 pm	',
      monTo: 'Mon 5:14:59 pm',
      tueTo: 'Tue 5:14:59 pm	',
      wedTo: 'Wed 5:14:59 pm	',
      thursTo: 'Thurs 5:14:59 pm	',
      friTo: 'Fri 5:14:59 pm	',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      note: '*Trades Date is based on the time of execution not request.',
    },
    preciousMetalsDealers: {
      title: 'Precious Metals Dealers',
      textOne:
        '{{brokerName}} maintains relationships with various approved dealers that make up {{brokerName}}’s approved network (the “Dealers”) for the purpose of buying and selling Precious Metals on behalf of its Clients. All of the Dealers will provide {{brokerName}} with LBMA/LPPM good delivery brand bars. The LBMA/LPPM maintains a list of refiners who meet certain criteria for assaying standards and bar quality.',
    },
    preciousMetalsPurity: {
      title: 'Precious Metals Purity',
      textOne:
        '{{brokerName}} will purchase Precious Metals that have a minimum purity content set forth by either the LBMA/LPPM or Sovereign Governments for all Products except 1kg bars, which will require a minimum purity of .9999 and silver products, which will have a purity content of .999.',
    },
    suspensionOrCancellationOfTransactions: {
      title: 'Suspension or Cancellation of Transactions',
      textOne:
        '{{brokerName}} may suspend, cancel, or execute only a portion of, purchases or sales with respect to Clients in the following circumstances:',
      listItemOne:
        'when trading of the Precious Metals is restricted on any one or more markets;',
      listItemTwo:
        'if {{brokerName}} determines that it is unable, for any reason, to determine the price or value of the Precious Metals or to execute an order;',
      listItemThree:
        'if the purchase or sale would, as determined by {{brokerName}} in its sole discretion, result in a violation of applicable law or regulation;',
      listItemFour:
        'during any disruption in the communication or computation systems used by {{brokerName}} to communicate with Dealers, to determine the price or value to execute orders;',
      listItemFive:
        'during any period in which {{brokerName}} has suspended its operations or is in the process of effecting an orderly liquidation of {{brokerName}};',
      listItemSix:
        'upon the occurrence of a force major event, including without limitation, war, strike, flood, terrorism, computer “hacking” event, power failure, earthquake or similar event (all such events being “Force Majeure Events”), that would prevent {{brokerName}} from fulfilling a purchase or sale order; or',
      listItemSeven:
        'for any other reason if {{brokerName}} in its sole discretion determines that such order would not be in the best interests of, or could have a material adverse effect on, {{brokerName}} or any Client.',
    },
    storageOfPreciousMetalsByAVaultingPartner: {
      title: 'Storage of Precious Metals by a Vaulting Partner',
      textOne:
        'Precious Metals purchased for storage through {{brokerName}} will be stored by a third party internationally recognized service provider (“Vaulting Partner”) selected by {{brokerName}}. Current Vaulting Partners are Brink’s Global Services USA, Loomis and Malca Amit. Vaulting Partners are subject to change without notice or may be added in the future.',
      textTwo:
        'Precious Metals stored in any vault are under 24-hour surveillance and are visually inspected on a regular basis by independent auditors.',
    },
    transportAndStorageInsurance: {
      title: 'Transport and Storage Insurance',
      textOne:
        'Transport of Precious Metals in connection with a purchase or sale will be provided by {{brokerCode}}’s Vaulting Partners or by {{brokerCode}}’s Dealers directly or through insured common carrier transportation services.',
      textTwo:
        'The transport and storage of Precious Metals by a Vaulting Partner will be insured under the Vaulting Partner’s insurance policy. For example, Lloyds of London insures all movement and storage of Precious Metals on behalf of Brink’s, Loomis, and Malca Amit for the full replacement value of the Precious Metals. The policy is an “all risks” policy, but does not cover losses for Force Majeure Events.',
    },
    takingPersonalPossessionOfPreciousMetals: {
      title: 'Taking Personal Possession of Precious Metals',
      textOne:
        'Any request by a Client to take possession of Precious Metals instead of storing them with a Vaulting Partner will be the sole decision of the Client.',
      textTwo:
        'A Client that requests delivery does so with an understanding that it bears all of the risks associated with removing Precious Metals from the Chain of Custody of an approved Vaulting Partner. Included in these risks is the potential loss of value that occurs when attempting to return Precious Metals to the chain of custody. This loss may be a result of the retesting and potential melting and reformation by a certified Refiner/Assayer that may be required prior to a Dealer accepting the Precious Metals.',
      textThree:
        'The Client also understands the risk and costs associated with self-storing and insuring Precious Metals if it so desires. Precious Metals will not be delivered to any Client or its custodian without the acceptance of risk associated with taking delivery outside of the chain of custody.',
    },
    auditingOfPreciousMetalsHoldings: {
      title: 'Auditing of Precious Metals Holdings',
      textOne:
        '{{brokerName}} has contracted with an internationally recognized audit/accounting firm (the “Auditor”) that will enter each Vaulting Partner’s facility in which {{brokerName}} stores Precious Metals to confirm all the holdings. The Auditor will count each bar and confirm by serial number, if applicable, or by the number of bars/coins in the vault.',
    },
    reporting: {
      title: 'Reporting',
      textOne:
        'After each trade, {{brokerName}} will provide the Client with a confirmation detailing the amount of Precious Metals bought or sold, the total execution price at which the Precious Metals were purchased or sold and the aggregate settlement amount.',
      textTwo:
        'On a monthly basis, {{brokerName}} will send electronically each Client who stores Precious Metals with {{brokerName}} a Client statement setting forth the value of such Client’s holdings, as defined by the current indicative sale price of the Products back to {{brokerCode}}’s Dealers, based on the closing price for the last business day of the preceding month.',
      textThree:
        'The {{brokerName}} statement will provide a detailed accounting of the holdings and a description of the quantity or fine weight of each bar/coin type held by the Client.',
    },
    taxAndOtherConsiderations: {
      title: 'Tax and Other Considerations',
      textOne:
        '{{brokerName}} does not provide tax advice and recommends Clients consult with appropriate investment, tax, legal, and/or other advisors in connection with the purchase, sale, and storage of Precious Metals.',
    },
    transfers: {
      title: 'Transfers',
      textOne:
        'Precious Metals purchased through {{brokerName}} can be transferred to a financial institution within the {{brokerName}} network. {{brokerName}} will work with the relevant financial institutions to complete the transfer process, and any costs thereof will be borne by the Client. If the transfer is to a financial institution that does not have a relationship with {{brokerName}}, no transfer will be affected and the Client may be required to liquidate its holdings or accept delivery assuming all risk as outlined under the section titled Taking Personal Possession of Precious Metals.',
    },
    currencyOperations: {
      title: 'Currency Operations',
      textOne:
        'All purchases and sales of Products and Services will be made in US dollars.',
    },
    regulatoryConsiderations: {
      title: 'Regulatory Considerations',
      textOne:
        '{{brokerName}} is not a financial institution, broker-dealer or a futures commission merchant, and is not currently subject to regulation by the SEC, the CFTC or any self-regulatory organization.',
      textTwo:
        '{{brokerName}} is not an investment adviser or a commodity trading advisor and does not provide any investment advice or commodity trading advice.',
      textThree:
        'Precious Metals are not securities or futures contracts. Therefore, the protections afforded by securities and commodities laws will not apply to an investment in Precious Metals through {{brokerName}}, including without limitation, the protections provided by SIPC. All transactions are executed by Gold Bullion International, LLC, a commodity broker-dealer registered with the New York Investor Protection Bureau.',
    },
    accountConsiderations: {
      title: 'Account Considerations',
      textOne:
        'Cash balances which are not invested in Precious Metals will remain commingled in one non-interest-bearing account which is not protected by the FDIC.',
    },
    taxpayerIdInformation: {
      title: 'Taxpayer ID Information',
      textOne:
        'U.S. Clients will be required to provide a Social Security Number or Tax Identification Number to {{brokerCode}} as part of the Account opening and Account maintenance process. Under penalty of perjury, Client certifies that:',
      list: {
        listItemOne:
          'The Social Security Number or Taxpayer ID number shown on its application form is its correct taxpayer identification number (or it is waiting for a number to be issued to it); and',
        listItemTwo:
          'It is not subject to backup withholding because: (a) it is exempt from backup withholding, or (b) it has not been notified by the Internal Revenue Service (IRS) that it is subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified it that it is no longer subject to backup withholding; and',
        listItemThree: 'It is a U.S. citizen or other U.S. person; and',
        listItemFour:
          'The FATCA code(s) entered on its application form (if any) indicating that it is exempt from FATCA reporting is correct.',
      },
    },
    otherTerms: {
      title: 'Other Terms',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      and: 'and',
      textOne:
        'The terms of this Agreement, and Client’s Account with {{brokerName}} shall also be governed by {{brokerName}}’s',
      textTwo:
        ', the terms of which are incorporated herein by reference and made a part hereof. By checking the box acknowledging thatClient has read this Agreement in full and consents to be bound by all of the terms hereof, Client is also acknowledging that it has read in full and consents to be bound by all of the terms of {{brokerName}}’s Terms of Use and PrivacyPolicy. {{brokerCode}} reserves the right to change any of the terms of this Agreement at any time without prior notice to Client, and any such changes will be effective upon Client and itsAccount(s) five (5) business days from its posting. Client’s continued use of {{brokerCode}}’s Services and Products following any such modification constitutes its acceptance of any such changes to this Agreement.',
    },
  },
  welcomeFluent: {
    titleTag: 'Open account | {{brokerName}}',
    emailCta: 'How does {{brokerName}} work? Learn more',
    emailLabel: 'Email Address',
    conitnue: 'Continue',
    metalstreamTitle: 'Welcome to {{brokerName}}',
    metalstreamSubtitle:
      'Make automatic monthly investments in real precious metals with MetalStream™. It works with any {{brokerCode}} account.',
    title: 'Open a New Account',
    promoCode: 'PromoCode',
    subtitle: 'Get started in 3 easy steps: open an account, fund, invest.',
    subtitleEmail:
      'Welcome to {{brokerName}}, get started by entering your email address.',
    getStarted: 'Get Started',
    login: 'Login',
    haveApplication: 'Already started an application?',
    applyInMinutes: {
      title: ' Apply In Minutes',
      description:
        'Set up a new account quickly; just answer a few questions to create a secure profile.',
    },
    brokerage: {
      title: 'Works Like a Brokerage',
      description:
        'Choose and fund your investments; every order is bid out to a network of suppliers for the best price possible.',
    },
    international: {
      title: 'True Ownership, From Salt Lake to Singapore',
      description:
        'Buy, sell and store at various independent vaults from the top names in security – including Brinks & Loomis – audited and fully insured. Or take delivery any time. Always your choice.',
      descriptionMetal:
        'Buy, sell, store your metals where you choose. Close to home or various international locations, your assets are held with the top names in security – Brinks, Loomis, Malca-Amit – independently audited and fully insured.',
    },
    setIt: {
      title: 'Set It and Forget It',
      description:
        'Every month, MetalStream invests the amount you choose, from your bank or your {{brokerCode}} balance, accumulating gold and silver over time. Start, stop or adjust any time. ',
    },
  },
  selectPath: {
    titleTag: 'Choose an account type | {{brokerName}}',
    title: 'What will your account be used for?',
    options: {
      standard: {
        titleTag: 'Standard options | {{brokerName}}',
        title: 'Standard investing',
        subtitle: 'Taxable individual, joint, business, or trust accounts',
        owner: {
          title: 'Who will own the account?',
          me: 'Just me',
          joint: 'Me & another adult (spouse, partner, etc.)',
          trust: 'A trust with me as the trustee',
          business: 'A business with me as the authorized representative',
        },
        business: {
          title: 'What kind of business is it?',
          llc: 'Limited Liability Company (LLC)',
          corp: 'Corporation (C- or S-corp)',
          partnership: 'Partnership (Standard or LLLP)',
          sole: 'Sole Proprietorship',
        },
      },
      retirement: {
        titleTag: 'Retirement options | {{brokerName}}',
        title: 'Retirement',
        subtitle: 'Traditional IRA, Roth IRA, SEP IRA, or Simple IRA accounts',
        retirementPersonalTitle:
          'What kind of retirement account do you want to open?',
        businessOwner: {
          titleTag: 'Retirement business options | {{brokerName}}',
          title: 'What kind of retirement account do you want to open?',
          simple: {
            title: 'Simple IRA',
            taxDefer:
              'Tax-deferred retirement savings option available to many small businesses, generally with 100 or fewer employees',
            contributions:
              'Employer contributions (either matching or nonelective contributions) are mandatory and tax-deductible.',
            employer: 'Employer cannot have any other retirement plan',
          },
          sep: {
            title: 'SEP IRA',
            selfEmployed:
              'Available to self-employed individuals, sole proprietors, partnerships, and small business owners',
            contributions:
              "Employers can contribute 25% of an employee's compensation or $57,000 (whichever is less) for tax year 2020. The limit is $58,000 for 2021.",
          },
        },
        owner: {
          titleTag: 'Retirement individual options | {{brokerName}}',
          title: 'Who will own the retirement account?',
          titlePersonal: 'What kind of retirement account do you want to open?',
          me: 'Just me',
          business: 'A business with me as the authorized representative',
          personalType: {
            roth: {
              title: 'Roth IRA',
              taxFree: 'Tax-free growth and withdrawal',
              easyFund:
                'Easily fund by transfer from an existing Roth IRA, rollover of a Roth 401k, or contribution',
              usOnly:
                'Open to U.S. taxpayers only; subject to qualification requirements*',
            },
            traditional: {
              title: 'Traditional IRA',
              taxDefer: 'Grow your investments tax-deferred;',
              easyFund:
                'Easily fund by transfer from an existing IRA, rollover of a 401k or other plan, or contribution',
              usOnly:
                'Open to U.S. taxpayers only; subject to qualification requirements*',
            },
          },
          businessType: {},
        },
      },
      utma: {
        titleTag: 'UTMA options | {{brokerName}}',
        title: 'Who will own the account?',
        custodian: 'An UTMA for a minor with me as custodian',
        trust: 'A trust with me as the trustee',
      },
      gift: {
        title: 'As a gift',
        subtitle: 'Uniform Transfer to Minors Act (UTMA) account',
      },
    },
    standardAccount: 'Standard Account',
    taxAdvantagedAccount: 'Tax-advantaged Account',
    openAnAccountForRetirement:
      'Open an account for retirement or estate planning and enjoy tax-deferred or tax-free investing.',
    upgradeAccount: {
      title: 'Create a Verified Account',
      upgradeYourBasicAccount:
        'Upgrade your delivery-only account to a verified, taxable investment account.',
    },
    openNewAccount: {
      title: 'Open a new account',
      openAVerifiedAccount: 'Open a verified, taxable investment account.',
    },
  },

  loginFluent: {
    titleTag: 'Log into  your account | {{brokerName}}',
    titleTagProgress: 'Save progress | {{brokerName}}',
    title: 'Log into your account',
    login: 'Log in',
    logout: 'Log Out',
    saveExit: 'Save & Exit ',
    application: 'Haven’t started an application?',
    getStarted: 'Get started.',
    email: 'Username',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    progress: 'Let’s make sure we can save your progress',
    emailAddress: 'Email address',
    createPassword: 'Create password',
    continue: 'Continue',
    theQuote:
      '"Gold and silver have a world market that transcends national borders, politics, religions, and race. A person may not like someone else’s religion, but he’ll accept his gold "',
    theQuoteAuthor: '– Robert Kiyosaki, author of Rich Dad, Poor Dad',
  },
  salesAssistedFluent: {
    titleTag: 'Start an assisted registration | {{brokerName}}',
    title: 'Start an assisted registration',
    description:
      'Help a user fill out an application and send them an invite to review and finish the application themselves. Start by entering the user email address.  The user’s history, if any, will be returned for review.',
    email: 'Customer’s email',
    choose: 'Choose this customer',
  },
  createAccount: 'Create your account',
  secureAccount: 'Secure your account',
  titleTagSecureAccount: 'Secure your account | {{brokerName}}',
  titleTagDob: 'Birth date | {{brokerName}}',
  titleTagEin: 'EIN | {{brokerName}}',
  titleTagIdentityVerification: 'Identity verification | {{brokerName}}',
  titleTagIrs: 'Subject of backup with holdings | {{brokerName}}',
  titleTagName: 'Name | {{brokerName}}',
  titleTagPhoneNumber: 'Phone number | {{brokerName}}',
  titleTagBusinessName: 'Business name | {{brokerName}}',
  titleTagTrustName: 'Trust name | {{brokerName}}',
  titleTagMarital: 'Marital status | {{brokerName}}',
  titleTagAmount: 'Amount | {{brokerName}}',
  titleTagEmploymentStatus: 'What’s your Employment Status?',
  name: 'Name',
  loading: 'Loading',
  yourName: 'Your name',
  dob: 'Birth date',
  ein: 'EIN',
  irs: 'Subject of backup with holdings',
  identityVerification: 'Identity verification',
  phoneNumber: 'Phone number',
  address: 'Enter address',
  fund: 'Fund your account',
  financialProfile: 'Enter financial profile',
  amount: 'Amount',
  titleTagReview: 'Review | {{brokerName}}',
  review: 'Review',
  secondaryOwner: 'Add secondary owner',
  marital: 'Marital status',
  businessName: 'Business name',
  trustName: 'Trust name',
  secureBusiness: 'Business details',
  businessType: 'Business type',
  businessAddress: 'Business address',
  minor: 'Minor information',
  looksGood: 'Looks Good',
  impersonateRegistration: 'Finish and send invitation',
  update: 'Update',
  country: 'Country',
  region: 'Region',
  dolater: 'I’ll do this later',
  gethelp: 'Get Help',
  recommend: 'Recommended',
  employmentStatus: 'Employment status',
  secure: {
    secureYourAccount: 'Now, let’s secure your account',
    storePreciousMetals:
      'Store your precious metals in the most-trusted independent vaults around the world. Or take delivery. Before we can do that, let’s guarantee only you can access your account.',
    storePreciousMetalsIRA:
      'Store your precious metals in the most-trusted independent vaults around the world. Before we can do that, let’s guarantee only you can access your account.',
    whatNeed: 'What you’ll need:',
    additionalBusinessInfo:
      'Information about you, the account holder, and information about the business itself.',
    basics: 'The basics: Name, Birth date',
    ifInUs:
      'If you’re a United States Citizen, your Social Security Number or Tax ID',
    joint: {
      note: 'Information about both you and your fellow joint account holder',
      basics:
        'The basics: Name and Birth date of both you and the other account holder',
      ifInUs:
        'If you’re a United States Citizen, your Social Security Number or Tax ID',
      einInfo: 'Information about the joint: Name, EIN (if applicable)',
    },
    business: {
      note:
        'Information about you, the account holder, and information about the business itself.',
      basics: 'The basics: Your name, Birthdate',
      ifInUs:
        'If you’re a United States Citizen, your Social Security Number or Tax ID',
      einInfo: 'Business information: Name, Business type, EIN (if applicable)',
    },
    trust: {
      note:
        'Information about you, the grantor of the trust, and information about the trust itself.',
      basics: 'The basics: Your name, Birthdate',
      ifInUs:
        'If you’re a United States Citizen, your Social Security Number or Tax ID',
      einInfo: 'Trust information: Name, EIN (if applicable)',
    },
    utma: {
      note:
        'Information about you, the adult custodian, and the minor you are gifting to.',
      basics: 'The basics: Name and Birthdate of both you and the minor.',
      ifInUs:
        'If you’re a United States Citizen, your Social Security Number or Tax ID',
      einInfo:
        'IF the minor is a United States Citizen, their Social Security Number or Tax ID',
    },
    secureMyAccount: 'Secure My Account',
  },
  secureName: {
    nameTitle: "Let's get started, what's your full legal name?",
    businessNameTitle: "What's your full legal name?",
    title: "What's your full legal name?",
    infoHighlight: 'Did you know?',
    info:
      'We are trusted by over 200,000 customers for precious metals investments.',
  },
  businessEinInfo:
    'Business information: Name, Business type, EIN (If applicable)',
  additionalBusinessInfo:
    'Information about you, the account holder, and information about the business itself.',
  continue: 'Continue',
  openAccount: 'Open Account',
  NewYork: 'New York',
  SaltLakeCity: 'Salt Lake City',
  Zurich: 'Zurich',
  London: 'London',
  Sydney: 'Sydney',
  Singapore: 'Singapore',
  Toronto: 'Toronto',
  Ohio: 'Ohio',
  Dallas: 'Dallas',
  Delivery: 'Delivery',
  FractionalHoldings: 'Fractional Holdings',
  secureDob: {
    title: 'Hi {{name}}, nice to meet you. What’s your birth date?',
    subtitle:
      'We use this to help verify your identity and protect your account.',
    month: 'Month',
    day: 'Day',
    year: 'Year',
  },
  secureIdentity: {
    title: 'What’s your country of citizenship?',
    subtitle:
      '{{brokerCode}} accounts are open to most anyone around the world. Your country of citizenship helps keep our records accurate and determine what else we might need to know. If you’re a resident alien of the United States with a tax ID, choose the United States',
    country: 'Country',
    iraNote:
      'Only US residents can open a retirement account with {{brokerCode}}.',
    utmaNote: 'Only US residents can open a UTMA account with {{brokerCode}}.',
  },
  secureIdentitySSN: {
    title: 'Let’s confirm your identity',
    titleMakeSure: 'To make sure you’re you. Let’s confirm your identity.',
    subtitle:
      'We use your SSN/TIN to verify your identity and secure your account, and to report for taxes when required.  We take security and privacy seriously; your personal information is always encrypted and safe',
    last4Subtitle:
      'We use the last 4 digits of your SSN/TIN to verify your identity and secure your account.',
    ssn: 'Social Security Number (SSN) or Tax ID (TIN)',
    last4Ssn: 'Last 4 digits of SSN or Tax ID (TIN)',
    ssnUTMA: 'Social Security Number',
  },
  secureIdentityDetails: {
    title: 'What’s your primary form of identification?',
    titleIDType: 'Identification type',
    titleIDNumber: 'ID number',
    titleIssueDate: 'Issue date',
    titleExpirationDate: 'Expiration date',
    titleIssuedBy: 'Issued by',
  },
  securePhoneNumber: {
    title: 'What’s your phone number?',
    note: 'Only USA phone numbers are accepted for retirement accounts.',
  },
  secureEmploymentStatus: {
    title:
      'Select your employment status to help us better understand your financial background.',
    options: {
      employed: 'Employed',
      retired: 'Retired',
      unemployed: 'Unemployed',
    },
    titleOccupationCategory: 'Occupation Category',
    titleOccupation: 'Occupation',
    titlePriorOccupationCategory: 'Prior Occupation Category',
    titlePriorOccupation: 'Prior Occupation',
    titleEmployerAddress: 'Employer Address',
    titleSourceOfIncome: 'Source of Income',
  },
  businessSecureIdentitySSN: {
    title: 'To make sure you’re you. Let’s confirm your identity.',
  },
  secureIdentityIRS: {
    title:
      'Have you ever been notified by the IRS that you are subject to backup withholding?',
    yes: 'Yes (very rare)',
    no: 'No',
  },
  secureAddress: {
    titleTag: 'Secure address | {{brokerName}}',
    address: 'Address',
    title:
      "Great. We have what's needed to secure your assets. Now, let's make it easy to take delivery if you ever need to.",
    titleIRA: "Great. We have what's needed to secure your assets.",
    subtitle:
      'To ensure only you can take delivery of your assets, if you ever want to, we need to confirm a valid address for you.  You can change it or add more later in your account.',
    subtitleIRA:
      "Please provide your primary residential address, even if you cannot receive mail at the address. If applying on behalf of a company or other person, use it's legally registered address.",
    highlight: 'Did you know?',
    info:
      'Our customers have shipped over $1 billion worth of precious metals to their doorsteps.',
    infoPersonalIra:
      'We are trusted by over 200,000 customers for precious metals investments.',
  },
  secureSecondaryAddress: {
    title: 'Does {{name}} also live at {{address}}?',
    titleMissingData:
      'Does the secondary member also live at the same residence?',
  },
  secureMinorAddress: {
    title: 'Does {{name}} share the same home address as you?',
    titleMissingData: 'Does minor share the same home address as you?',
  },
  secureSecondaryAddressEnter: {
    title: 'What’s {{name}} current address?',
    titleEmptyName: "What's the secondary member's address?",
    titleSameAddress: 'What’s {{name}} and {{mainName}} current address?',
    subtitle:
      'Please provide their current residential address (no PO boxes), i.e. where they live, even if they don’t want to receive deliveries there.',
  },
  secureAddressEnter: {
    title: 'What’s your current address, {{name}}?',
    titleMissingData: 'What’s your current address?',
    subtitle:
      'Please provide your current residential address (no PO boxes), i.e. where you live, even if you don’t want to receive deliveries there.',
    searchAddress: 'Search your address',
    street: 'Address',
    employerStreet: 'Employer Address',
    aptOrSuite: 'Apt, Suite, Building # (optional)',
    city: 'City',
    state: 'State / Province / Region',
    employerState: 'State',
    postalCode: 'Zip / Postal',
    zipCode: 'Zip code',
    notFound: 'Nothing found, enter your address manually',
  },
  secureMinorAddressEnter: {
    titleMissingData: "What's minor current address?",
    title: 'What’s {{name}} current address?',
    titleSameAddress: 'What’s {{name}} and {{mainName}} current address?',
  },
  secureMinorAddressEnterMissingData: {
    title: "What's minor current address?",
  },
  secureSecondary: {
    nameTitle:
      'Tell us about the person you’re opening this account with. What’s their full legal name?',
  },
  secondaryMinor: {
    nameTitle:
      'Tell us about the minor you’re gifting this account to. What’s their full legal name?',
  },
  secureMinorIdentity: {
    title: 'What’s {{name}}’s country of citizenship?',
  },
  secureMinorIdentityMissingInfo: {
    title: 'What’s minor’s country of citizenship?',
  },
  secureMinorIdentitySSN: {
    title: 'Let’s confirm {{name}}’s identity',
  },
  secureMinorIdentitySSNMissingInfo: {
    title: 'Let’s confirm minors’s identity',
  },
  secureSecondaryDob: {
    title: 'When was {{name}} born?',
    secureSecondarySob:
      'We use this to help verify your identity and protect your account.',
  },
  secureSecondaryDobMissingInfo: {
    title: 'When was secondary owner born?',
  },
  secureMinorDobMissingInfo: {
    title: 'When was minor born?',
  },
  secureSecondaryPhoneNumber: {
    title: 'What is {{name}}’s phone number?',
  },
  secureSecondaryPhoneNumberMissingInfo: {
    title: 'What is secondary owner’s phone number?',
  },
  secureMinorPhoneNumberMissingInfo: {
    title: 'What is minor’s phone number?',
  },
  secureSecondaryIdentity: {
    title: 'What’s {{name}}’s  country of citizenship?',
  },
  secureSecondaryIdentityMissingInfo: {
    title: "Let's confirm the secondary owner's identity",
  },
  secureSecondaryIdentitySSN: {
    title: 'Let’s confirm {{name}}’s identity',
  },
  secureSecondaryIdentitySSNMissingInfo: {
    title: "What's the secondary owner's country of citizenship?",
  },
  secureSecondaryIdentityIRS: {
    title:
      'Have you or {{name}} ever been notified by the IRS that you are subject to backup withholding?',
  },
  secureSecondaryIdentityIRSMissingInfo: {
    title:
      'Have you or secondary owner ever been notified by the IRS that you are subject to backup withholding?',
  },
  retirementBusinessName: {
    title: 'Let’s get started, What’s the legal name of your business?',
    businessName: 'Business name',
  },
  retirementMaritalStatus: {
    title: 'What’s your marital status?',
    subtitle: 'Your marital status is required for tax reporting purposes.',
    single: 'Single',
    married: 'Married',
    'divorced/separated': 'Divorced/Separated',
    'divorced/widowed': 'Widowed',
  },
  secureTrustName: {
    title: 'What is your Trust’s legal name?',
    subtitle:
      'Please double check it matches the name at the top of your trust documents',
    name: 'Trust name',
  },
  secureAccountTrustEinQuestion: {
    title: 'Does your trust have an employer identification number (EIN)?',
    yes: 'Yes (uncommon)',
    no: 'No',
  },
  secureAccountEin: {
    title: 'Does your trust have an employer identification number (EIN)?',
    ein: 'EIN Number',
    noEin: 'My trust has an EIN (rare)',
  },
  addressDone: {
    title: 'Now you’ve got an address on file',
    subtitle:
      'We use this to help keep your account secure. And if you ever want to take a distribution/delivery, you can send your assets here. Or add another address later in your account.',
  },
  verifyBusinessType: {
    title:
      'First, tell us a little about your business. What type of entity is it?',
  },
  verifyBusinessName: {
    title: 'What is your business’s legal name?',
    businessName: 'Business name',
  },
  verifyBusinessEin: {
    title: 'What’s your business’s employer identification number (EIN)?',
    ein: 'EIN Number',
    noEin: 'My business has an EIN',
  },
  verifyBusinessAddress: {
    title: 'Where is your business located?',
    subtitle:
      'Please use the legally registered main office of your business to be sure we can identify it.',
  },
  verifyReview: {
    title: 'Ok, here’s what we have so far',
    subtitle: 'To edit something simply click on what you want to change.',
    trustName: 'Trust name',
    businessName: 'Business name',
    businessType: 'Business type',
    ein: 'EIN',
    address: 'Address',
    businessAddress: 'Business Address',
    businessEinLabel: 'Business EIN',
    businessTypeLabel: 'Business type',
    businessAddressLabel: 'Business address',
    businessNameLabel: 'Business name',
  },
  metalstream: {
    titleTag: 'MetalStream | {{brokerName}}',
    metalStream: 'MetalStream',
    titleTagMonthlyInvest: 'Monthly Investment | {{brokerName}}',
    monthlyInvest: 'Monthly Investment',
    titleTagAllocation: 'Allocate Funds | {{brokerName}}',
    allocation: 'Allocate Funds',
    titleTagGold: 'Choose Gold | {{brokerName}}',
    gold: 'Choose Gold',
    titleTagSilver: 'Choose Silver | {{brokerName}}',
    silver: 'Choose Silver',
    review: 'Overview',
    titleTagReview: 'Overview | {{brokerName}}',
    titleTagComplete: 'Complete | {{brokerName}}',
    complete: 'Complete',
    investTitle:
      'How much would you like to invest each month for your recurring MetalStream deposit?',
    investSubTitle:
      'Let’s get set up. First let us know how much you want to invest. Then you’ll choose what investments to buy and finally where the funds will come from.',
    amountField: 'Monthly Investment',
    monthlyInvestment: 'Monthly Investment',
    goldRange: 'Gold',
    silverRange: 'Silver',
    allocateTitle: 'Allocate your funds between gold and silver ',
    allocateSubtitle:
      'Select the proportion of your investment you’d like to allocate to gold and/or silver. In the next step, you’ll pick the specific products you want to buy.',
    goldTitle: 'What kind of gold do you want to buy?',
    goldSubtitle:
      'Choose your preferred gold investment and where you want it stored.',
    metalPriceSubtitle: '{{priceOz}}/oz',
    silverTitle: 'What kind of silver do you want to buy?',
    silverSubtitle:
      'Choose your preferred silver investment and where you want it stored.',
    reviewTitle:
      'Please review and submit your recurring MetalStream Investment.',
    reviewSubtitle:
      'Take a moment to review your selections and see if everything looks right.',
    reviewAllocation: 'Allocation',
    depositAmount: 'Deposit amount',
    depositType: 'Deposit type',
    reviewGold: 'Gold',
    reviewSilver: 'Silver',
    reviewMetal: 'Gold and Silver Type',
    welcomeTitle: 'Let’s set up your recurring MetalStream investments.',
    welcomePointOne: 'First let us know how much you want to invest.',
    welcomePointTwo: 'Then you’ll choose what investments to buy.',
    welcomePointThree: 'Lastly you’ll decide where the funds will come from.',
    secureYourAccount:
      'You have successfully set up your recurring MetalStream investments. Now, let’s secure your account.',
    secureName: {
      info:
        '{{brokerCode}} securely stores over $3 billion dollars of our customers assets globally.',
    },
    summaryTitle:
      'You have successfully set up your recurring MetalStream investments.',
    summaryInfo: 'You should know:',
    autoDeposits: 'Auto-deposits process on the {{day}}th of the month',
    autoTrades: 'Auto-trades are executed between the 23rd and the 26th',
    lowBalance:
      'While enabled, if your auto-deposit is unavailable or delayed, auto-trades will execute up to the lower of your available balance or this amount while MetalStream is enabled.',
    termsAndConditions: {
      title: 'MetalSTREAM Terms of Use',
      textOne:
        'MetalSTREAM allows for systematic investments into physical gold or silver on a monthly basis. Your participaton in this program is subject to the {{brokerName}} customer agreement and the following terms:',
      itemOne:
        "To be eligible for any current months' automatic investment program, you must enroll prior to the 15th of the month.",
      itemTwo:
        'Trade execution dates are on the 24th of each month, or in the event the 24th is not a valid business day, the next business day after the 24th.',
      itemThree:
        'In selecting this service, you hereby authorize {{brokerName}} to execute monthly purchase transactions for the desired product and dollar amount that you have specified.',
      itemFour:
        'To participate in MetalSTREAM, you must specificy a funding method - via on-demand charge of an outside account or from your pre-funded balance - and total investment, as well as directing funds to specific products from the choices available in the Applications MetalSTREAM settings.',
    },
  },
  financialProfileSetup: {
    profileTitle: 'Now, build out your financial profile.',
    profileIntro:
      'We have a few questions about you and your finances. This information can help us provide more personalized advice.',
    personalGoalsDesc: 'What is your personal goals for this IRA account?',
    personalGoalsOptions: {
      retirementSavings: 'Retirement savings',
      wealthAccumulation: 'Wealth accumulation',
      income: 'Income(via dividends & interest payments)',
    },
    fundSourceIntro: 'What will be the initial source of funds?',
    fundOutgoingSourceIntro: 'What will be the ongoing source of funds?',
    fundInitialSourceOtherIntro: 'Please specify',
    fundOngoingSourceOtherIntro: 'Please specify',
  },
  fundAccount: {
    titleTag: 'Fund account | {{brokerName}}',
    limitationCopyCheck:
      'For deposits via check, there is a limit of {{maxAmount}} per week.',
    limitationCopyWire:
      'For deposits via wire, there is a limit of {{maxAmount}} per transaction.',
    limitationCopyCrypto:
      'For deposits via crypto, there is a limit of {{maxAmount}} per transaction.',
    limitationACH:
      'For deposits via ACH, there is a limit of {{maxAmount}} per day',
    limitationCopyMetalStream:
      'For  metal stream deposits, there is a limit of {{maxAmount}}',
    metalTitle:
      'How would you like to fund your recurring MetalStream investment?',
    addMetalBankTitle: 'Connect to my bank',
    addMetalBankDescription:
      'Safely log into your bank to establish a connection and make quick, easy transfers. We use a popular service called Plaid to securely set up these connections. Connections are ready to use instantly.',
    manualMetalTitle: 'I will prefund my account manually',
    manualMetalDescription:
      'For Metalstream to work manually you’ll need to ensure you make your deposits by the {{reccuringInvestment}} of every month.',
    normalTitle: 'How do you want to fund your account?',
    normalSubtitle:
      'To guarantee the best possible pricing and availability, {{brokerCode}} accounts are prefunded like a brokerage. Select how you’d like to make your first deposit.',
    addBankTitle: 'Connect a Bank Account',
    addBankSubtitle: 'Easy, electronic transfers; Limit {{limit}}/day',
    addBankDescription:
      'Securely connect your bank account to make transfers when you choose. Log into your bank, or enter the information from a check, to set up easy “ACH” transfers.',
    wireTitle: 'Wire Transfer',
    wireSubtitle: 'Invest large amounts',
    wireDescription:
      'We provide you with the information to send us a wire transfer through your bank. Funds are available the same or next business day.',
    checkTitle: 'Check',
    checkSubtitle: 'Easy but funds clear slower; Limit {{limit}}/week',
    checkDescription:
      'We provide you with the information you need to send us a check in the mail. Funds are available to trade 5 business days after we deposit your check.',
    cryptoTitle: 'Cryptocurrency',
    cryptoSubtitle: 'Invest large amounts; Limit {{limit}}/transfer',
    cryptoDescription:
      'We use Bitpay to facilitate crypto transfers. Funds are converted to USD and deposited on your account by the next business day or sooner.',
    skipModalTitle: 'Are you sure?',
    skipModalSubtitle:
      'You can continue without funding, but you won’t be able to invest until you’ve made your initial deposit.',
    skipSkip: 'Continue funding my account',
    SKIP: 'I Understand; Skip For Now',
    transferIRATitle: 'Transfer from an existing IRA',
    transferIraSubtitle: 'Invest as much as you want',
    transferIRADescription:
      'If you already have an IRA – for example with a broker like Fidelity or Schwab, or with a self-directed custodian – just tell us how much you want to transfer and we do the rest. No limits; move as much cash as you need from your other account.',
    rolloverTitle: 'Rollover from a qualified retirement account',
    rolloverSubtitle: 'No limits; send funds from your workplace plan',
    rolloverDescription:
      'If you have a 401k, 403b, or other qualified plan, you can transfer funds into your new IRA. We’ll provide you the information you need to send to your plan manager',
    cashTitle: 'Contribution',
    cashSubtitle: 'Deposit up to the annual limit',
    cashDescription:
      'Make a cash contribution to your new IRA that will count toward your IRS-established annual contribution limits. We’ll give you instructions for sending a wire or check.',
    amountTitle: 'How much do you plan to invest?',
    transferAmountTitle: 'How much do you plan to transfer?',
    amountSubtitle:
      'We’ll provide instructions on how to complete your {{type}} transfer once we’re done here.',
    plaidTitle:
      'You’ve successfully linked your account! How much do you plan to invest?',
    plaidSubtitle:
      'Deposits typically take 2-3 days for funds to be available arrive in your account.',
    plaidManualTitle:
      'Your bank account is almost ready. First, tell us how much you want to deposit.',
    plaidManualSubtitle:
      'Once you verify the deposits we make in your account, we’ll start the transfer',
    amountFieldLabel: 'Deposit amount',
    amountTransferFieldLabel: 'Transfer amount *',
    transferTerms: 'ACH transfer terms of use.',
    agreeToAuthorizeMicro:
      'I authorize {{brokerCode}} to take a deposit of this amount from my account ending in {{accountNum}} and',
    agreeToAuthorize:
      'I authorize {{brokerCode}} to take a deposit of this amount from my {{bankName}} account ending in {{accountNum}} and the',
    survivalTitle:
      'Lastly, how do the two of you want to handle account inheritance?',
    survivingHolderTitle: 'The surviving account holder',
    survivingHolderSubtitle: 'Most popular',
    survivingHolderDescription:
      'In a joint account with rights of survivorship (Joint WROS) the surviving  account holder inherits the assets in our account if the other passes.',
    estateTitle: 'My estate',
    estateSubtitle: 'Less common',
    estateDescription:
      'With a joint tenants in common account (Joint TIC) the estate of the deceased will receive their portion of the account',
  },
  secureIdentityIRSSubject: {
    me: 'Me',
    secondary: '{{name}}',
    both: 'Both of us',
    title: 'Who is subject to backup withholding?',
  },
  standardReview: {
    title: 'Alright, before we open your account, does this look right?',
    subtitle: 'To edit something simply click on what you want to change.',
    yourName: 'Name',
    address: 'Address',
    yourBirthday: 'Birthday',
    yourSsn: 'SSN / TIN',
    yourCitizenship: 'Citizenship',
    yourPhone: 'Phone number',
    secondaryName: '{{name}}’s name',
    secondaryBirthday: '{{name}}’s Birthday',
    secondarySsn: '{{name}}’s SSN / TIN',
    secondaryCitizenship: '{{name}}’s Citizenship',
    trustName: 'Trust name',
    trustEin: 'Trust EIN',
    maritalStatus: 'Marital Status',
    depositAmount: '{{deposit}} deposit',
    microDepositAmount: '{{deposit}} micro deposit',
    recurringPayment: 'recurring payment',
    from: 'FroACH transfer from',
    starting: 'Scheduled {{date}}',
    personalInfo: 'Personal information',
    trustInfo: 'Trust information',
    minorInfo: 'Minor’s information',
    secondaryInfo: 'Secondary holder’s information',
    businessInfo: 'Business information',
    recurringInfo: 'Recurring investment',
    fundTypes: {
      plaid: 'ACH transfer from {{bankName}} ...{{last4digits}}',
      manual: 'Manual deposit',
      micro: 'From {{type}} {{subtype}} - {{last4digits}}',
      accountBalance: 'From account balance',
      wire: 'Via wire transfer; instructions provided once account is approved',
      check: 'Via check; instructions provided once account is approved',
      crypto:
        'Via cryptocurrency; instructions provided once account is approved',
      transferIRA: 'Transferring from existing IRA',
      rollover: 'Rollover from another retirement account',
      cash: 'Cash contribution',
      IRATransfer: 'Transferring from existing IRA',
      Rollover: 'Rollover',
      AnnualContribution: 'Contribution',
    },
  },
  fundModal: {
    changeTitle: 'What would you like to change?',
    setupTitle: 'How would you like to fund your account?',
    changeMethod: 'Change funding method',
    chooseMethod: 'Choose funding method',
    setDeposit: 'Set funding amount',
    editDeposit: 'Edit funding amount',
  },
  agreement: {
    titleTag: 'Agreement | {{brokerName}}',
    titleTagEquity: 'Equity agreement | {{brokerName}}',
    title: 'You are about to open an individual investment account',
    trustTitle: 'You are about to open a Trust account',
    jointTitle: 'You are about to open a joint investment account',
    businessTitle: 'You are about to open a corporate account',
    utmaTitle: 'You are about to open an UTMA account',
    iraTraditionalTitle: 'You are about to open a Traditional IRA account',
    iraRothTitle: 'You are about to open a Roth IRA account',
    iraSepTitle: 'You are about to open a Sep IRA account',
    iraSimpleTitle: 'You are about to open a Simple IRA account',
    metalTc:
      'I authorize {{brokerCode}} to debit my {{bankName}} account XXXX{{last4}} in the amount of {{amount}} per month for my MetalStream automatic investments',
    metalTcMicro:
      'I authorize {{brokerCode}} to debit my account XXXX{{last4}} in the amount of {{amount}} per month for my MetalStream automatic investments',
    metalTcLinkText: 'MetalStream terms of use',
    continuing: 'By continuing:',
    paragraph1:
      'You acknowledge that you understand and agree to the terms of <5>the (<1>{{broker}}</1>) Account Agreement</5>. This important agreement details your rights as owner of your investment and our responsibilities to you, including that:',
    bulletpoints: {
      metal:
        'MetalStream automatic investments will be made once monthly. Currently, deposits are withdrawn on the <bold>{{day}}th</bold> each month, and investments are made on the <bold>24th</bold>;',
      point1:
        'Your investments will be held under bailment, in the name you provided, inside our allocated vault network, as evidenced on our books and records;',
      point2:
        'Any balance you deposit with us is similarly held in escrow for your benefit at a U.S. bank of our choice;',
      point3:
        '{{brokerCode}} makes no claim on your assets other than for any unpaid fees you may owe to us, and we do not hypothecate or otherwise lien your holdings except as you direct us;',
      point4:
        'You may redeem your holdings at any time by selling back at the then current bid price or by taking delivery; and,',
      point5:
        'These terms are subject to some reasonable but important limits to protect us and you from fraud and other risks.',
    },
    paragraph2:
      'It is our firm belief that our allocated precious metals storage – at independent vaults with full replacement value insurance and regular auditing – provides users with the best possible ownership experience. It is safer and more secure than home storage without the downsides of securitized products like ETFs.',
    paragraph3:
      'That, together with our unique marketplace, where every order is bid to our global network of market makers for competitive execution, allows us to provide {{brokerCode}} account holders with a low-cost, easy and highly valuable service.',
    paragraph4:
      'Before you can take advantage of all your new {{brokerCode}} account offers, you should review and understand these important terms.',
    acknowledgeMetalStream:
      ' I authorize {{brokerCode}} to debit my {{bankName}} account ...{{last4digits}} in the amount of {{amount}} per month for my ',
    acknowledgeMetalStreamAccountBalace:
      'I authorize {{brokerCode}} to debit my account balance in the amount of {{amount}} per month for my',
    acknowledge: 'I understand and agree to the',
    metalStreamTerms: 'MetalStream automatic investments',
    haaTerms: '{{brokerName}} Customer Agreement',
    download: 'View/Download Full Agreement',
    openAccount: 'Open Account',
    upgradeAccount: 'Upgrade Account',
    agreeAndContinue: 'Agree and continue',
    please: 'Please scroll to review entire agreement before continuing',
    titleGS:
      'You are about to open an investment account with GOLDSILVER, LLC (“GoldSilver”)',
    paragraphGS1:
      'By clicking "I Agree" below, you, the client, acknowledge that you have read, understood, and agree to be legally bound by all of the terms and conditions of the User Agreement and Terms of Purchase and Sale (“User Terms”), including all policies and disclosures referred to therein. You further acknowledge and agree that:',
    numberPointsGS: {
      point1:
        'You have had the opportunity to review the User Terms in its entirety;',
      point2:
        'You understand the terms and conditions contained in the User Terms and agree to be bound by all of them;',
      point3:
        'Your acceptance of the User Terms is legally binding, as if you had physically signed the User Terms in writing;',
      point4:
        'The User Terms govern your relationship with GoldSilver, including your use of the services and products provided by GoldSilver.',
    },
    paragraphGS2:
      'If you do not agree to the terms of the User Terms, please do not proceed to open an investment account with GoldSilver.',
    downloadGS: 'View/download full User Terms and Terms of Purchase and Sale',
    acknowledgeGS: 'I understand and agree to be bound by all of the',
    termsGS: '{{brokerName}} User Terms and Terms of Purchase and Sale',
  },
  reviewTitle: {
    mainHeading: {
      primaryHolder: 'Primary Holder Info',
      custodian: 'Custodian Info',
      authorizedAgent: 'Authorized Agent Info',
    },
    secondaryHeading: {
      secondaryHolder: 'Secondary Holder Info',
      minor: 'Minor Info',
      legalEntity: 'Legal Entity Info',
    },
  },
  iraCustodian: {
    findCustodian: {
      title: 'Find your current IRA custodian',
      description:
        'This is the company that manages the IRA you’re transferring from.',
      dontSee: 'Don’t see your custodian?',
      addManually: 'Add manually.',
      noCustodian: "Don't see your custodian...",
    },
    details: {
      title: 'Enter your custodian details manually',
      description: 'Current custodian information:',
    },
    accountNumber: {
      title: 'What’s your account number at this custodian?',
      description:
        'In order to initiate your account transfer we’ll need to first get your account number.',
    },
    transfer: {
      title:
        'Are you transferring everything from your IRA or just a portion of it?',
      description: 'You can transfer all or part of your existing IRA.',
      fullTransfer: 'Full transfer',
      partial: 'Partial',
    },
    type: {
      title: 'What kind of IRA are you transferring from?',
    },
    review: {
      title: 'Alright, before we initiate your transfer, does this look right?',
      description: 'To edit something simply click on what you want to change.',
      iraReview: `{{amount}} {{- transferType}} from {{- iraType}} IRA ({{- accountNumber}}) at  {{- custodianName}}`,
      labels: {
        custodianName: 'Custodian name',
        custodianAddress: 'Custodian address',
        custodianPhoneNumber: 'Phone number',
        custodianFaxNumber: 'Fax number',
        transferType: 'Transfer type',
        accountNumber: 'Account number',
      },
    },
  },
  equityAgreement: {
    rothTitle:
      'You are about to open a Roth IRA account. First, please review the Equity Trust agreement.',
    sepTitle:
      'You are about to open a SEP IRA account. First, please review the Equity Trust agreement.',
    simpleTitle:
      'You are about to open a Simple IRA account. First, please review the Equity Trust agreement.',
    traditionalAccount:
      'You are about to open a Traditional IRA account. First, please review the Equity Trust agreement.',
    howItWorks:
      'IRAs are provided in partnership with Equity Trust, a leading custodian of over $30 billion in alternative assets. For IRA specific questions, like picking the correct account type or contribution limits, contact Equity at: (800) 955-3434 x5381. Note: Equity charges a fee of ${{equitySetupFee}}/year for each IRA account opened via {{brokerName}}. See account agreements for full details.',
    learnMore: 'Learn more here.',
    tcView: 'View Terms and Conditions',
    equityDummy1: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ornare enim egestas dolor.
    Egestas purus bibendum pretium tincidunt. Sed porttitor erat vitae id non id. Neque habitasse
    gravida purus arcu cras molestie. In dictum faucibus sit vel turpis lobortis ac sem. Pretium
    amet, magna tincidunt nibh. Sit volutpat cras vulputate eu, volutpat montes, eu nibh. Integer
    quis sit a eget convallis massa. Ac ut mus pretium viverra lacus et. Phasellus enim magna pulvinar
    dictum cras non euismod. Elementum pretium iaculis purus, condimentum nibh vulputate malesuada.
    Facilisi ac elementum congue habitasse mauris volutpat non nibh fusce. Condimentum vitae, eu aliquam,
    justo, natoque scelerisque tristique. Neque magna suscipit etiam purus, ornare. Lectus in sit consequat neque et
    est mauris, eget. At erat purus consequat elit a maecenas convallis aliquam nullam. Venenatis viverra sollicitudin
    est, molestie nec aliquet imperdiet in. Sapien tristique diam pharetra,
    quam condimentum aliquam pulvinar eget. Purus venenatis bibendum varius in.`,
    equityDummy2: `
    Vivamus sed eros id massa elementum blandit quis eu neque. Aenean posuere nisi accumsan, sodales augue quis,
    ultricies dolor. Mauris cursus risus turpis, et dapibus nunc dapibus tempor. Sed suscipit nisl fermentum
    faucibus malesuada. Morbi consectetur auctor luctus. Praesent tempus venenatis massa eget varius.
    Sed elit turpis, tincidunt porttitor metus nec, condimentum sagittis elit. Cras vel semper magna.
    In luctus ut augue lacinia gravida. Nunc imperdiet interdum est, et pellentesque dolor commodo quis.
    Sed ac ex eu purus dictum tincidunt ut nec lorem. Nunc faucibus semper ipsum sit amet elementum.
    Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Cras consequat viverra
    libero, sit amet dictum ante lobortis sit amet.
    `,
    equityDummy3: `
    Vivamus sed eros id massa elementum blandit quis eu neque. Aenean posuere nisi accumsan, sodales augue quis,
    ultricies dolor. Mauris cursus risus turpis, et dapibus nunc dapibus tempor. Sed suscipit nisl fermentum
    faucibus malesuada. Morbi consectetur auctor luctus. Praesent tempus venenatis massa eget varius.
    Sed elit turpis, tincidunt porttitor metus nec, condimentum sagittis elit. Cras vel semper magna.
    In luctus ut augue lacinia gravida. Nunc imperdiet interdum est, et pellentesque dolor commodo quis.
    Sed ac ex eu purus dictum tincidunt ut nec lorem. Nunc faucibus semper ipsum sit amet elementum.
    Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Cras consequat viverra
    libero, sit amet dictum ante lobortis sit amet.
    `,
    note:
      'Please read the following licence agreement carefully and scroll down to the end',
    docusignNote:
      'After submitting your application, please monitor your email for documents requiring signature from Equity Trust.',
  },
  kycProcessing: {
    titleTag: 'Submitting application | {{brokerName}}',
    review: 'Reviewing Application...',
  },
  kycSuccess: {
    titleTag: 'Next steps | {{brokerName}}',
    title:
      'Congratulations. You made a smart choice for your money. Here’s what happens next:',
    goto: 'Go To My Account',
    verifyTitle: 'We verify your identity',
    verifyDescription:
      'We double check all of the information submitted. If you need any further info we’ll follow up with you.',
    transferTitle: 'We transfer cash from your bank',
    transferDescription:
      'We contact the financial institution you set up and request the transfer. This usually takes 2-3 days. We’ll let you know as soon as the funds arrive.',
    metalsTitle: 'You buy & store or deliver precious metals',
    metalsDescription:
      'Once your account is verified and funding is ready you are ready to make your first investment.',
    fundAccountTitle: 'Fund your account',
    fundAccountDescription:
      'You’ll find instructions inside our app on how to make a deposit{{method}}. The sooner you fund, the sooner you can invest.',
  },
  kycFail: {
    titleOne: 'Thank you for upgrading your account with {{brokerName}}!',
    titleTwo: 'Thank you for signing up with {{brokerName}}!',
    subtitle:
      'As part of our standard verification process, please click to provide the following documents to complete your account setup.',
  },
  kycDone: {
    titleTag: 'Processing verification | {{brokerName}}',
    title: 'Processing verification',
    subtitle:
      'We’re verifying your additional documentation. We’ll email you when the process is complete or if we have any questions.',
    titleSkip: 'Verification skipped',
    subtitleSkip:
      'Before you can use all the features of your new account, you will need to verify your identity. Until then you can access the app to look around and pick back up any time.',
  },
  kycVerification: {
    titleTag: 'Documents requested | {{brokerName}}',
    titleTagProofOfIdentity: 'Proof of identity | {{brokerName}}',
    titleTagproofOfResidency: 'Proof of residence | {{brokerName}}',
    titleTagproofOfSocialSecurity: 'Proof of social security | {{brokerName}}',
    proofOfIdentity: 'Proof of identity',
    proofOfResidency: 'Proof of residence',
    proofOfSocialSecurity: 'Proof of social security',
    proofOfOwnership: 'Operating Agreement',
    proofCcStatement: 'Credit Card Statment',
    proofUtility: 'Utility Bill',
    proofBankStatement: 'Bank Statement',
    proofOfIdentityNamed: 'Proof of Identity for {{name}}',
    proofOfResidencyNamed: 'Proof of residence at {{address}} for {{name}}',
    proofOfSocialSecurityNamed: 'Proof of social security for {{name}}',
    proofOfOwnershipNamed: 'Proof of Ownership for {{name}}',
    proofOfIdentitySubtitle: 'Which type of photo ID will you provide:',
    chooseMethod: 'Choose an upload method',
    chooseFromFollowing:
      'Before making your first purchase you’ll need to upload a photo of an ID. This helps us ensure your account is safe & secure.',
    chooseFromFollowingSSC:
      'Before making your first purchase you’ll need to upload a photo of a social security card. This helps us ensure your account is safe & secure.',
    identityPageTitle:
      'Please follow instructions below to upload your identity documents',
    identityPageTitleSecondary:
      'Please follow instructions below to upload {{name}}’s identity documents',
    proofOfResidenceFor: 'Proof of Residence at {{address}} for {{name}}',
    proofOfResidenceForDesc:
      'Choose from the following; first page only, clearly showing your name and address.',
    proofOfResidenceForDescWithoutUtilityBill: 'Choose from the following:',
    companyDocs:
      'Please submit a copy corporate resolution stating that you can act on behalf of {{company}}.',
    companyDocsDesc:
      'This is usually the last page of the LLC/Corporate document that shows your name, business name, and is stamped by a notary.',
    partnershipDocs: 'Please submit a copy of your partnership agreement.',
    partnershipDocsDesc:
      'This is a document that shows both your name and the name of the partnership.',
    soleDocs: 'Please submit a copy of your sole proprietorship statement.',
    soleDocsDesc: 'This is simply a document stating.',
    trustDocs:
      'Please submit a copy of your trust documents stating that you can act on behalf of the Trust.',
    trustDocsDesc:
      'This is usually the last page of the Trust document that shows the client’s name, trust name, and is stamped by a notary.',
    dropHere: 'Drop your image here or upload from your files',
    dropHereMobile: 'Drop your image here or upload from your device',
    tapToChange: 'Wrong document? Click here to change it',
    supports: 'Supports: JPG, PNG, or PDF',
    supportsWothoutPdf: 'Supports: JPG, PNG or JPEG',
    pdfLoading: 'Loading PDF preview...',
    bankStatementTitle: 'Submit a bank statement',
    bankStatementSubtitle:
      'First page only, clearly showing your name, address and full bank account number dated within the past 3 months.',
    ccTitle: 'Submit a credit card',
    ccSubtitle:
      'First page only, clearly showing your name and address dated within the past 3 months.',
    mcTitle: 'Submit a medicare card',
    mcSubtitle:
      'First page only, clearly showing your name and address dated within the past 3 months.',
    sscTitle: 'Submit a social security card',
    sscSubtitle:
      'First page only, clearly showing your name and address dated within the past 3 months.',
    utilTitle: 'Submit a utility bill',
    utilSubtitle:
      'First page only, clearly showing your name and address dated within the past 3 months.',
    vcTitle: 'Submit a voided check',
    vcSubtitle:
      'First page only, clearly showing your name and address dated within the past 3 months.',
    titleTagDriversLicense: 'Drivers License | {{brokerName}}',
    titleTagPassport: 'Passport | {{brokerName}}',
    titleTagOther: 'Government id | {{brokerName}}',
    driversLicense: 'Drivers License',
    passport: 'Passport',
    other: 'Other government issued ID',
    titleTagCreditCardStatement: 'Credit Card Statement | {{brokerName}}',
    creditCardStatement: 'Credit Card Statement',
    titleTagUtilityBill: 'Utility Bill | {{brokerName}}',
    utilityBill: 'Utility Bill',
    titleTagBankStatement: 'Bank Statement | {{brokerName}}',
    bankStatement: 'Bank Statement',
    titleTagVoidedCheck: 'Voided Check | {{brokerName}}',
    voidedCheck: 'Voided Check',
    titleTagSocialSecurityCard: 'Social Security Card | {{brokerName}}',
    socialSecurityCard: 'Social Security Card',
    titleTagMediacareCard: 'Medicare Card | {{brokerName}}',
    mediacareCard: 'Medicare Card',
    webcam: 'Webcam',
    webcamDescription: 'Take a picture using the webcam on your computer.',
    phone: 'Phone',
    phoneDescription: 'Take a picture using the camera on your phone.',
    fileUpload: 'File Upload',
    fileUploadDescription: 'Upload a file from your computer.',
    proofOfIdentityTitle: 'Please upload a photo of the front of your ID.',
    proofOfSocialSecurityTitle:
      'Please upload a photo of the front of your social security card.',
    proofOfIdentityTitlePassport: 'Please upload a photo of your ID.',
    proofOfIdentityTitleWebcamPassport: 'Please take a photo of your ID.',
    proofOfIdentityTitleWebcam: 'Please take a photo of the front of your ID.',
    proofOfSocialSecurityTitleWebcam:
      'Please take a photo of the front of your social security card.',
    front: 'Front',
    back: 'Back',
    captureFront: 'Capture Front',
    captureID: 'Capture ID',
    checkItemOne: 'Hold your ID up to your camera.',
    checkItemTwo: 'Don’t hold your ID next to your face.',
    checkItemThree: 'Don’t tilt your ID - hold it straight.',
    checkSSCItemOne: 'Hold your social security card up to your camera.',
    checkSSCItemTwo: 'Don’t hold your social security card next to your face.',
    checkSSCItemThree:
      'Don’t tilt your social security card - hold it straight.',
    fileUploadDescriptionMobile:
      'Take a picture and upload it, or upload an existing file from your mobile.',
    titleTagCorporateDocument: 'LLC/Corporate document | {{brokerName}}',
    titleTagSoleProprietorshipStatement:
      'Sole Proprietorship Statement | {{brokerName}}',
    titleTagTrustDocuments: 'Trust documents | {{brokerName}}',
    titleTagPartnershipAgreement: 'Partnership Agreement | {{brokerName}}',
  },
  refresh: {
    title: 'Are you active?',
    cta:
      "You were registered as not active, please confirm that you are active in the next minute, if you don't you will be logged out.",
  },
  redirection: {
    title: 'Redirect user',
    cta:
      'You already have user on old registration portal and you will be redirected',
  },
  cameraAccess: {
    title: 'You don’t have access to your camera',
    cta1: 'Your camera is not plugged in or is blocked.',
    cta2:
      ' Please check camera connection or allow camera access for this page and try again.',
  },
  existingApplication: {
    title: 'Resume application?',
    cta:
      'We noticed you previously started an application.  Would you like to resume filling out that application or start a new one?',
    continueCurrentApplication: ' Resume application',
    openAccount: 'Start a new application',
    startNewApplicationNote: `By starting a new application you will overwrite any existing progress.`,
    startedApplicaton: 'Application started ',
    by: ' by {{owner}}',
  },
  exitConfirmation: {
    title: 'Are you sure you want to exit registration?',
    cta:
      'Your progress will be saved. Return at any point to resume your new account registration.',
    saveExit: 'Save & Exit',
    continueRegistration: 'Continue Registration',
  },
  salesAssisted: {
    invitationTitle: 'Assisted registration',
    invitationSubtitle: 'Invitation sent',
    invitationDescription:
      'An invitation to complete this registration has been sent to {{email}}',
    returnToBackOffice: 'Ok, return to back office',
  },
  saveAndClose: {
    title: 'Save & close draft',
    succes: {
      description:
        'This draft application was saved successfully.  You are now safe to exit.',
      exit: 'Exit impersonation',
      conitnue: 'Continue editing',
    },
    error: {
      description:
        'This draft was not saved.  Please keep this window open and try again later.',
      close: 'Close',
    },
  },
  exampleFluent: {
    title: 'Create new user',
    generalInfo: {
      title: 'General information',
      subtitle:
        'Enter your information below as the first authorized user on the new account',
    },
    firstName: 'First Name*',
    lastName: 'Last Name*',
    middleName: 'Middle Initial',
    suffix: 'Suffix',
    email: 'Email Address*',
    password: 'Password*',
    continue: 'Continue',
  },
  exampleEmail: {
    title: 'Enter email adddress',
    email: 'Email Address*',
    continue: 'Continue',
  },
  resetPassword: {
    title: 'Reset your password',
    securityQuestion: {
      title: 'Security Question',
      subtitle:
        'Please answer the security question to gain access to your account:',
      label: 'Reset Password',
    },
    resetSuccessful: {
      description:
        'You have successfully reset your password. Continue to the login page.',
    },
    resetSent: {
      description1:
        'An email has been sent to the provided address with further instructions to reset your password. Please check your inbox and follow the steps provided. If you do not receive an email, please contact ',
      descriptionLink: 'customer service',
      description2: ' for more assistance.',
    },
    newPassword: {
      subtitle: 'Please enter your new password.',
      label: 'New Password:',
      savePassword: 'Save Password',
    },
    emptyEmail: 'You must enter your email address first.',
  },
  setPassword: {
    title: 'Set your password',
    resetSuccessful: {
      description:
        'You have successfully reset your password. Continue to the login page.',
    },
    resetSent: {
      description1:
        'An email has been sent to the provided address with further instructions to reset your password. Please check your inbox and follow the steps provided. If you do not receive an email, please contact ',
      descriptionLink: 'customer service',
      description2: ' for more assistance.',
    },
    newPassword: {
      subtitle: 'Please enter your new password.',
      label: 'New Password:',
      savePassword: 'Save Password',
    },
    emptyEmail: 'You must enter your email address first.',
  },
  footer: {
    copyright: 'Copyright © {{year}} {{Copyright}} All Rights Reserved.',
    menu: {
      disclaimer: 'Disclaimer',
      accessibilityAssistant: 'Accessibility Assistant',
      gdpr: 'Gdpr',
    },
  },
  termsAndPrivacy: {
    text:
      'Use of this site/application and your {{brokerName}} account are expressly subject to our',
    terms: 'Terms of Service',
    and: 'and',
    privacy: 'Privacy Policy',
  },
  videos: {
    secureYourAccountTitle: 'Why do you need my social security number?',
    modalSSNVideoTitle: 'Why do we need your SSN?',
    genericPlaybackError: 'Video playback error!',
  },
};
